"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetInitialRender = exports.SubscriptionSelectAdminDtoStatusEnum = exports.SubscriptionSelectAdminDtoCanceledReasonEnum = exports.SubscriptionStatusEnum = exports.SubscriptionCanceledReasonEnum = exports.SnapshotDataType = exports.ReferenceType = exports.ReclaimSettingsStatus = exports.ReclaimAlgorithmTypes = exports.ProductScope = exports.ProductTypeEnum = exports.PrePurchasePromotionsStatus = exports.OrganizationStatus = exports.ModalCtaType = exports.MaxPurchaseTriggerExclusionTypeEnum = exports.InvoiceStatus = exports.IntegrationStatus = exports.FreeTrialSelectAdminDtoStatusEnum = exports.FreeTrialStatusEnum = exports.FloaterRelativePosition = exports.FeatureKey = exports.EmailPrompt = exports.EmailOptOutReason = exports.ElementTextType = exports.ElementRelativePosition = exports.DonationType = exports.DonationStatus = exports.DonationCreditStatus = exports.CouponCodeTriggerExclusionTypeEnum = exports.CouponCodeSyncType = exports.CouponCodeStatus = exports.ColorTheme = exports.CollectionTypeEnum = exports.CampaignType = exports.CampaignTriggerType = exports.CampaignTriggerTokenCreationPolicy = exports.CampaignTriggerScope = exports.CampaignStatus = exports.CampaignOfferType = exports.CampaignOfferScope = exports.BannerCtaType = exports.AdminCollectionUpdateTypeEnum = exports.AdminCollectionCreateTypeEnum = exports.AdminCollectionTypeEnum = exports.AdminAccountCreditCreateStatusEnum = exports.AdminAccountCreditCreateRestrictionEnum = exports.AccountOnboardingReferralType = exports.AccountOnboardingGoalType = exports.AccountOnboardingCharitableCauses = exports.AccountCreditRestriction = void 0;
exports.FreeTrialsApiAxiosParamCreator = exports.FileUploadsApi = exports.FileUploadsApiFactory = exports.FileUploadsApiFp = exports.FileUploadsApiAxiosParamCreator = exports.FeaturesApi = exports.FeaturesApiFactory = exports.FeaturesApiFp = exports.FeaturesApiAxiosParamCreator = exports.DonationsApi = exports.DonationsApiFactory = exports.DonationsApiFp = exports.DonationsApiAxiosParamCreator = exports.DonationCreditsApi = exports.DonationCreditsApiFactory = exports.DonationCreditsApiFp = exports.DonationCreditsApiAxiosParamCreator = exports.CouponCodesApi = exports.CouponCodesApiFactory = exports.CouponCodesApiFp = exports.CouponCodesApiAxiosParamCreator = exports.ConsumerApi = exports.ConsumerApiFactory = exports.ConsumerApiFp = exports.ConsumerApiAxiosParamCreator = exports.CollectionsApi = exports.CollectionsApiFactory = exports.CollectionsApiFp = exports.CollectionsApiAxiosParamCreator = exports.CategoriesApi = exports.CategoriesApiFactory = exports.CategoriesApiFp = exports.CategoriesApiAxiosParamCreator = exports.CampaignsApi = exports.CampaignsApiFactory = exports.CampaignsApiFp = exports.CampaignsApiAxiosParamCreator = exports.AuthApi = exports.AuthApiFactory = exports.AuthApiFp = exports.AuthApiAxiosParamCreator = exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = exports.AccountsApi = exports.AccountsApiFactory = exports.AccountsApiFp = exports.AccountsApiAxiosParamCreator = exports.WidgetStatus = void 0;
exports.TrackApiFactory = exports.TrackApiFp = exports.TrackApiAxiosParamCreator = exports.SubscriptionsApi = exports.SubscriptionsApiFactory = exports.SubscriptionsApiFp = exports.SubscriptionsApiAxiosParamCreator = exports.ShopifyApi = exports.ShopifyApiFactory = exports.ShopifyApiFp = exports.ShopifyApiAxiosParamCreator = exports.ReportsApi = exports.ReportsApiFactory = exports.ReportsApiFp = exports.ReportsApiAxiosParamCreator = exports.PreviewApi = exports.PreviewApiFactory = exports.PreviewApiFp = exports.PreviewApiAxiosParamCreator = exports.PartnerApi = exports.PartnerApiFactory = exports.PartnerApiFp = exports.PartnerApiAxiosParamCreator = exports.OrganizationsApi = exports.OrganizationsApiFactory = exports.OrganizationsApiFp = exports.OrganizationsApiAxiosParamCreator = exports.OrdersApi = exports.OrdersApiFactory = exports.OrdersApiFp = exports.OrdersApiAxiosParamCreator = exports.InvoicesApi = exports.InvoicesApiFactory = exports.InvoicesApiFp = exports.InvoicesApiAxiosParamCreator = exports.IntegrationsApi = exports.IntegrationsApiFactory = exports.IntegrationsApiFp = exports.IntegrationsApiAxiosParamCreator = exports.ImpersonatorApi = exports.ImpersonatorApiFactory = exports.ImpersonatorApiFp = exports.ImpersonatorApiAxiosParamCreator = exports.HostedApi = exports.HostedApiFactory = exports.HostedApiFp = exports.HostedApiAxiosParamCreator = exports.FreeTrialsApi = exports.FreeTrialsApiFactory = exports.FreeTrialsApiFp = void 0;
exports.WidgetApi = exports.WidgetApiFactory = exports.WidgetApiFp = exports.WidgetApiAxiosParamCreator = exports.WebhooksApi = exports.WebhooksApiFactory = exports.WebhooksApiFp = exports.WebhooksApiAxiosParamCreator = exports.UtilitiesApi = exports.UtilitiesApiFactory = exports.UtilitiesApiFp = exports.UtilitiesApiAxiosParamCreator = exports.TrackApi = void 0;
var tslib_1 = require("tslib");
var axios_1 = require("axios");
var common_1 = require("./common");
var base_1 = require("./base");
var AccountCreditRestriction;
(function (AccountCreditRestriction) {
    AccountCreditRestriction["Donations"] = "DONATIONS";
    AccountCreditRestriction["GivzPlatformFee"] = "GIVZ_PLATFORM_FEE";
    AccountCreditRestriction["PaymentProcessingFee"] = "PAYMENT_PROCESSING_FEE";
})(AccountCreditRestriction = exports.AccountCreditRestriction || (exports.AccountCreditRestriction = {}));
var AccountOnboardingCharitableCauses;
(function (AccountOnboardingCharitableCauses) {
    AccountOnboardingCharitableCauses["AnimalsAndPets"] = "ANIMALS_AND_PETS";
    AccountOnboardingCharitableCauses["ArtsAndCulture"] = "ARTS_AND_CULTURE";
    AccountOnboardingCharitableCauses["BusinessAndEmployment"] = "BUSINESS_AND_EMPLOYMENT";
    AccountOnboardingCharitableCauses["ChildrenAndYouth"] = "CHILDREN_AND_YOUTH";
    AccountOnboardingCharitableCauses["Community"] = "COMMUNITY";
    AccountOnboardingCharitableCauses["CrimeAndJustice"] = "CRIME_AND_JUSTICE";
    AccountOnboardingCharitableCauses["DisasterRelief"] = "DISASTER_RELIEF";
    AccountOnboardingCharitableCauses["Education"] = "EDUCATION";
    AccountOnboardingCharitableCauses["EnvironmentAndNature"] = "ENVIRONMENT_AND_NATURE";
    AccountOnboardingCharitableCauses["FaithAndSpirituality"] = "FAITH_AND_SPIRITUALITY";
    AccountOnboardingCharitableCauses["Health"] = "HEALTH";
    AccountOnboardingCharitableCauses["HousingAndHungerRelief"] = "HOUSING_AND_HUNGER_RELIEF";
    AccountOnboardingCharitableCauses["HumanServices"] = "HUMAN_SERVICES";
    AccountOnboardingCharitableCauses["International"] = "INTERNATIONAL";
    AccountOnboardingCharitableCauses["MilitaryAndVeterans"] = "MILITARY_AND_VETERANS";
    AccountOnboardingCharitableCauses["Philanthropy"] = "PHILANTHROPY";
    AccountOnboardingCharitableCauses["ScienceAndResearch"] = "SCIENCE_AND_RESEARCH";
    AccountOnboardingCharitableCauses["Sports"] = "SPORTS";
})(AccountOnboardingCharitableCauses = exports.AccountOnboardingCharitableCauses || (exports.AccountOnboardingCharitableCauses = {}));
var AccountOnboardingGoalType;
(function (AccountOnboardingGoalType) {
    AccountOnboardingGoalType["DonateSalesToCharity"] = "DONATE_SALES_TO_CHARITY";
    AccountOnboardingGoalType["SpecialEvent"] = "SPECIAL_EVENT";
    AccountOnboardingGoalType["ImproveConversion"] = "IMPROVE_CONVERSION";
    AccountOnboardingGoalType["IncreaseAov"] = "INCREASE_AOV";
    AccountOnboardingGoalType["NotSure"] = "NOT_SURE";
})(AccountOnboardingGoalType = exports.AccountOnboardingGoalType || (exports.AccountOnboardingGoalType = {}));
var AccountOnboardingReferralType;
(function (AccountOnboardingReferralType) {
    AccountOnboardingReferralType["Ad"] = "AD";
    AccountOnboardingReferralType["Integration"] = "INTEGRATION";
    AccountOnboardingReferralType["Other"] = "OTHER";
    AccountOnboardingReferralType["Podcast"] = "PODCAST";
    AccountOnboardingReferralType["SearchEngine"] = "SEARCH_ENGINE";
    AccountOnboardingReferralType["ShopifyStore"] = "SHOPIFY_STORE";
    AccountOnboardingReferralType["SocialMedia"] = "SOCIAL_MEDIA";
})(AccountOnboardingReferralType = exports.AccountOnboardingReferralType || (exports.AccountOnboardingReferralType = {}));
var AdminAccountCreditCreateRestrictionEnum;
(function (AdminAccountCreditCreateRestrictionEnum) {
    AdminAccountCreditCreateRestrictionEnum["Donations"] = "DONATIONS";
    AdminAccountCreditCreateRestrictionEnum["GivzPlatformFee"] = "GIVZ_PLATFORM_FEE";
    AdminAccountCreditCreateRestrictionEnum["PaymentProcessingFee"] = "PAYMENT_PROCESSING_FEE";
})(AdminAccountCreditCreateRestrictionEnum = exports.AdminAccountCreditCreateRestrictionEnum || (exports.AdminAccountCreditCreateRestrictionEnum = {}));
var AdminAccountCreditCreateStatusEnum;
(function (AdminAccountCreditCreateStatusEnum) {
    AdminAccountCreditCreateStatusEnum["Active"] = "ACTIVE";
    AdminAccountCreditCreateStatusEnum["Expired"] = "EXPIRED";
    AdminAccountCreditCreateStatusEnum["Scheduled"] = "SCHEDULED";
    AdminAccountCreditCreateStatusEnum["Used"] = "USED";
})(AdminAccountCreditCreateStatusEnum = exports.AdminAccountCreditCreateStatusEnum || (exports.AdminAccountCreditCreateStatusEnum = {}));
var AdminCollectionTypeEnum;
(function (AdminCollectionTypeEnum) {
    AdminCollectionTypeEnum["Curated"] = "CURATED";
    AdminCollectionTypeEnum["Handpicked"] = "HANDPICKED";
})(AdminCollectionTypeEnum = exports.AdminCollectionTypeEnum || (exports.AdminCollectionTypeEnum = {}));
var AdminCollectionCreateTypeEnum;
(function (AdminCollectionCreateTypeEnum) {
    AdminCollectionCreateTypeEnum["Curated"] = "CURATED";
    AdminCollectionCreateTypeEnum["Handpicked"] = "HANDPICKED";
})(AdminCollectionCreateTypeEnum = exports.AdminCollectionCreateTypeEnum || (exports.AdminCollectionCreateTypeEnum = {}));
var AdminCollectionUpdateTypeEnum;
(function (AdminCollectionUpdateTypeEnum) {
    AdminCollectionUpdateTypeEnum["Curated"] = "CURATED";
    AdminCollectionUpdateTypeEnum["Handpicked"] = "HANDPICKED";
})(AdminCollectionUpdateTypeEnum = exports.AdminCollectionUpdateTypeEnum || (exports.AdminCollectionUpdateTypeEnum = {}));
var BannerCtaType;
(function (BannerCtaType) {
    BannerCtaType["Hidden"] = "HIDDEN";
    BannerCtaType["Modal"] = "MODAL";
    BannerCtaType["Url"] = "URL";
})(BannerCtaType = exports.BannerCtaType || (exports.BannerCtaType = {}));
var CampaignOfferScope;
(function (CampaignOfferScope) {
    CampaignOfferScope["Fixed"] = "FIXED";
    CampaignOfferScope["Subtotal"] = "SUBTOTAL";
    CampaignOfferScope["Token"] = "TOKEN";
    CampaignOfferScope["Total"] = "TOTAL";
})(CampaignOfferScope = exports.CampaignOfferScope || (exports.CampaignOfferScope = {}));
var CampaignOfferType;
(function (CampaignOfferType) {
    CampaignOfferType["Amount"] = "AMOUNT";
    CampaignOfferType["Percentage"] = "PERCENTAGE";
})(CampaignOfferType = exports.CampaignOfferType || (exports.CampaignOfferType = {}));
var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["Active"] = "ACTIVE";
    CampaignStatus["Archived"] = "ARCHIVED";
    CampaignStatus["Inactive"] = "INACTIVE";
    CampaignStatus["Scheduled"] = "SCHEDULED";
})(CampaignStatus = exports.CampaignStatus || (exports.CampaignStatus = {}));
var CampaignTriggerScope;
(function (CampaignTriggerScope) {
    CampaignTriggerScope["Subtotal"] = "SUBTOTAL";
    CampaignTriggerScope["Total"] = "TOTAL";
})(CampaignTriggerScope = exports.CampaignTriggerScope || (exports.CampaignTriggerScope = {}));
var CampaignTriggerTokenCreationPolicy;
(function (CampaignTriggerTokenCreationPolicy) {
    CampaignTriggerTokenCreationPolicy["Admin"] = "ADMIN";
    CampaignTriggerTokenCreationPolicy["Partner"] = "PARTNER";
    CampaignTriggerTokenCreationPolicy["Public"] = "PUBLIC";
})(CampaignTriggerTokenCreationPolicy = exports.CampaignTriggerTokenCreationPolicy || (exports.CampaignTriggerTokenCreationPolicy = {}));
var CampaignTriggerType;
(function (CampaignTriggerType) {
    CampaignTriggerType["AllOrders"] = "ALL_ORDERS";
    CampaignTriggerType["CouponCodes"] = "COUPON_CODES";
    CampaignTriggerType["MinPurchase"] = "MIN_PURCHASE";
    CampaignTriggerType["Products"] = "PRODUCTS";
    CampaignTriggerType["Token"] = "TOKEN";
})(CampaignTriggerType = exports.CampaignTriggerType || (exports.CampaignTriggerType = {}));
var CampaignType;
(function (CampaignType) {
    CampaignType["Shopify"] = "SHOPIFY";
    CampaignType["Hosted"] = "HOSTED";
})(CampaignType = exports.CampaignType || (exports.CampaignType = {}));
var CollectionTypeEnum;
(function (CollectionTypeEnum) {
    CollectionTypeEnum["Curated"] = "CURATED";
    CollectionTypeEnum["Handpicked"] = "HANDPICKED";
})(CollectionTypeEnum = exports.CollectionTypeEnum || (exports.CollectionTypeEnum = {}));
var ColorTheme;
(function (ColorTheme) {
    ColorTheme["Dark"] = "DARK";
    ColorTheme["Light"] = "LIGHT";
})(ColorTheme = exports.ColorTheme || (exports.ColorTheme = {}));
var CouponCodeStatus;
(function (CouponCodeStatus) {
    CouponCodeStatus["Active"] = "ACTIVE";
    CouponCodeStatus["Expired"] = "EXPIRED";
    CouponCodeStatus["Deleted"] = "DELETED";
    CouponCodeStatus["Scheduled"] = "SCHEDULED";
})(CouponCodeStatus = exports.CouponCodeStatus || (exports.CouponCodeStatus = {}));
var CouponCodeSyncType;
(function (CouponCodeSyncType) {
    CouponCodeSyncType["Incremental"] = "INCREMENTAL";
    CouponCodeSyncType["Full"] = "FULL";
})(CouponCodeSyncType = exports.CouponCodeSyncType || (exports.CouponCodeSyncType = {}));
var CouponCodeTriggerExclusionTypeEnum;
(function (CouponCodeTriggerExclusionTypeEnum) {
    CouponCodeTriggerExclusionTypeEnum["CouponCode"] = "COUPON_CODE";
    CouponCodeTriggerExclusionTypeEnum["MaxPurchase"] = "MAX_PURCHASE";
})(CouponCodeTriggerExclusionTypeEnum = exports.CouponCodeTriggerExclusionTypeEnum || (exports.CouponCodeTriggerExclusionTypeEnum = {}));
var DonationCreditStatus;
(function (DonationCreditStatus) {
    DonationCreditStatus["Claimed"] = "CLAIMED";
    DonationCreditStatus["Expired"] = "EXPIRED";
    DonationCreditStatus["Reclaimed"] = "RECLAIMED";
    DonationCreditStatus["Unclaimed"] = "UNCLAIMED";
})(DonationCreditStatus = exports.DonationCreditStatus || (exports.DonationCreditStatus = {}));
var DonationStatus;
(function (DonationStatus) {
    DonationStatus["Disbursed"] = "DISBURSED";
    DonationStatus["Hold"] = "HOLD";
    DonationStatus["Invoiced"] = "INVOICED";
    DonationStatus["Paid"] = "PAID";
    DonationStatus["Pledged"] = "PLEDGED";
    DonationStatus["Voided"] = "VOIDED";
})(DonationStatus = exports.DonationStatus || (exports.DonationStatus = {}));
var DonationType;
(function (DonationType) {
    DonationType["Claimed"] = "CLAIMED";
    DonationType["Reclaimed"] = "RECLAIMED";
})(DonationType = exports.DonationType || (exports.DonationType = {}));
var ElementRelativePosition;
(function (ElementRelativePosition) {
    ElementRelativePosition["Above"] = "ABOVE";
    ElementRelativePosition["Below"] = "BELOW";
    ElementRelativePosition["FirstChild"] = "FIRST_CHILD";
    ElementRelativePosition["LastChild"] = "LAST_CHILD";
})(ElementRelativePosition = exports.ElementRelativePosition || (exports.ElementRelativePosition = {}));
var ElementTextType;
(function (ElementTextType) {
    ElementTextType["Automatic"] = "AUTOMATIC";
    ElementTextType["Custom"] = "CUSTOM";
    ElementTextType["Dynamic"] = "DYNAMIC";
    ElementTextType["Ukraine"] = "UKRAINE";
})(ElementTextType = exports.ElementTextType || (exports.ElementTextType = {}));
var EmailOptOutReason;
(function (EmailOptOutReason) {
    EmailOptOutReason["HardBounce"] = "HARD_BOUNCE";
    EmailOptOutReason["Invalid"] = "INVALID";
    EmailOptOutReason["Redacted"] = "REDACTED";
    EmailOptOutReason["SoftBounce"] = "SOFT_BOUNCE";
    EmailOptOutReason["Spam"] = "SPAM";
    EmailOptOutReason["Unsubscribe"] = "UNSUBSCRIBE";
})(EmailOptOutReason = exports.EmailOptOutReason || (exports.EmailOptOutReason = {}));
var EmailPrompt;
(function (EmailPrompt) {
    EmailPrompt["IfMissing"] = "IF_MISSING";
    EmailPrompt["Off"] = "OFF";
    EmailPrompt["On"] = "ON";
})(EmailPrompt = exports.EmailPrompt || (exports.EmailPrompt = {}));
var FeatureKey;
(function (FeatureKey) {
    FeatureKey["CartDonations"] = "cartDonations";
    FeatureKey["CartPromotions"] = "cartPromotions";
    FeatureKey["CoreBenefits"] = "coreBenefits";
    FeatureKey["CuratedCharities"] = "curatedCharities";
    FeatureKey["CustomerSupportStandard"] = "customerSupportStandard";
    FeatureKey["DonateOnExpiration"] = "donateOnExpiration";
    FeatureKey["DonationSharing"] = "donationSharing";
    FeatureKey["ExperienceCobranding"] = "experienceCobranding";
    FeatureKey["ExperienceCustomization"] = "experienceCustomization";
    FeatureKey["ExperienceHideSearch"] = "experienceHideSearch";
    FeatureKey["ExperienceUnrestrictedHandpicked"] = "experienceUnrestrictedHandpicked";
    FeatureKey["HandpickedCharities"] = "handpickedCharities";
    FeatureKey["InstantDonations"] = "instantDonations";
    FeatureKey["Integrations"] = "integrations";
    FeatureKey["IntegrationsAttentive"] = "integrationsAttentive";
    FeatureKey["IntegrationsKlaviyo"] = "integrationsKlaviyo";
    FeatureKey["IntegrationsPeel"] = "integrationsPeel";
    FeatureKey["IntegrationsPostscript"] = "integrationsPostscript";
    FeatureKey["IntegrationsShopify"] = "integrationsShopify";
    FeatureKey["ManageDonationReminders"] = "manageDonationReminders";
    FeatureKey["MultipleCampaigns"] = "multipleCampaigns";
    FeatureKey["OneDonationCreditPerConsumer"] = "oneDonationCreditPerConsumer";
    FeatureKey["PosOrders"] = "posOrders";
    FeatureKey["PrePurchasePromotions"] = "prePurchasePromotions";
    FeatureKey["RechargeSettings"] = "rechargeSettings";
    FeatureKey["ReclaimedDonationCredits"] = "reclaimedDonationCredits";
    FeatureKey["ScheduledCampaigns"] = "scheduledCampaigns";
    FeatureKey["TopOffDonations"] = "topOffDonations";
    FeatureKey["TriggerDiscountCodes"] = "triggerDiscountCodes";
    FeatureKey["TriggerProducts"] = "triggerProducts";
})(FeatureKey = exports.FeatureKey || (exports.FeatureKey = {}));
var FloaterRelativePosition;
(function (FloaterRelativePosition) {
    FloaterRelativePosition["BottomCenter"] = "BOTTOM_CENTER";
    FloaterRelativePosition["BottomLeft"] = "BOTTOM_LEFT";
    FloaterRelativePosition["BottomRight"] = "BOTTOM_RIGHT";
    FloaterRelativePosition["MiddleLeft"] = "MIDDLE_LEFT";
    FloaterRelativePosition["MiddleRight"] = "MIDDLE_RIGHT";
    FloaterRelativePosition["TopLeft"] = "TOP_LEFT";
    FloaterRelativePosition["TopRight"] = "TOP_RIGHT";
})(FloaterRelativePosition = exports.FloaterRelativePosition || (exports.FloaterRelativePosition = {}));
var FreeTrialStatusEnum;
(function (FreeTrialStatusEnum) {
    FreeTrialStatusEnum["Active"] = "ACTIVE";
    FreeTrialStatusEnum["Expired"] = "EXPIRED";
})(FreeTrialStatusEnum = exports.FreeTrialStatusEnum || (exports.FreeTrialStatusEnum = {}));
var FreeTrialSelectAdminDtoStatusEnum;
(function (FreeTrialSelectAdminDtoStatusEnum) {
    FreeTrialSelectAdminDtoStatusEnum["Active"] = "ACTIVE";
    FreeTrialSelectAdminDtoStatusEnum["Expired"] = "EXPIRED";
})(FreeTrialSelectAdminDtoStatusEnum = exports.FreeTrialSelectAdminDtoStatusEnum || (exports.FreeTrialSelectAdminDtoStatusEnum = {}));
var IntegrationStatus;
(function (IntegrationStatus) {
    IntegrationStatus["Connected"] = "CONNECTED";
    IntegrationStatus["Failed"] = "FAILED";
    IntegrationStatus["NotConnected"] = "NOT_CONNECTED";
    IntegrationStatus["Uninstalled"] = "UNINSTALLED";
})(IntegrationStatus = exports.IntegrationStatus || (exports.IntegrationStatus = {}));
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["Deleted"] = "DELETED";
    InvoiceStatus["Draft"] = "DRAFT";
    InvoiceStatus["Issued"] = "ISSUED";
    InvoiceStatus["Paid"] = "PAID";
    InvoiceStatus["Uncollectible"] = "UNCOLLECTIBLE";
    InvoiceStatus["Voided"] = "VOIDED";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
var MaxPurchaseTriggerExclusionTypeEnum;
(function (MaxPurchaseTriggerExclusionTypeEnum) {
    MaxPurchaseTriggerExclusionTypeEnum["CouponCode"] = "COUPON_CODE";
    MaxPurchaseTriggerExclusionTypeEnum["MaxPurchase"] = "MAX_PURCHASE";
})(MaxPurchaseTriggerExclusionTypeEnum = exports.MaxPurchaseTriggerExclusionTypeEnum || (exports.MaxPurchaseTriggerExclusionTypeEnum = {}));
var ModalCtaType;
(function (ModalCtaType) {
    ModalCtaType["Close"] = "CLOSE";
    ModalCtaType["Hidden"] = "HIDDEN";
    ModalCtaType["Url"] = "URL";
})(ModalCtaType = exports.ModalCtaType || (exports.ModalCtaType = {}));
var OrganizationStatus;
(function (OrganizationStatus) {
    OrganizationStatus["Active"] = "ACTIVE";
    OrganizationStatus["Inactive"] = "INACTIVE";
})(OrganizationStatus = exports.OrganizationStatus || (exports.OrganizationStatus = {}));
var PrePurchasePromotionsStatus;
(function (PrePurchasePromotionsStatus) {
    PrePurchasePromotionsStatus["Off"] = "OFF";
    PrePurchasePromotionsStatus["On"] = "ON";
    PrePurchasePromotionsStatus["Scheduled"] = "SCHEDULED";
    PrePurchasePromotionsStatus["Superseded"] = "SUPERSEDED";
})(PrePurchasePromotionsStatus = exports.PrePurchasePromotionsStatus || (exports.PrePurchasePromotionsStatus = {}));
var ProductTypeEnum;
(function (ProductTypeEnum) {
    ProductTypeEnum["Partner"] = "PARTNER";
    ProductTypeEnum["Shopify"] = "SHOPIFY";
})(ProductTypeEnum = exports.ProductTypeEnum || (exports.ProductTypeEnum = {}));
var ProductScope;
(function (ProductScope) {
    ProductScope["FixedAmountPerOrder"] = "FIXED_AMOUNT_PER_ORDER";
    ProductScope["FixedAmountPerQuantity"] = "FIXED_AMOUNT_PER_QUANTITY";
    ProductScope["PercentageOfProductTotal"] = "PERCENTAGE_OF_PRODUCT_TOTAL";
    ProductScope["PercentageOfSubtotal"] = "PERCENTAGE_OF_SUBTOTAL";
})(ProductScope = exports.ProductScope || (exports.ProductScope = {}));
var ReclaimAlgorithmTypes;
(function (ReclaimAlgorithmTypes) {
    ReclaimAlgorithmTypes["AllProRata"] = "ALL_PRO_RATA";
    ReclaimAlgorithmTypes["FeaturedEqual"] = "FEATURED_EQUAL";
    ReclaimAlgorithmTypes["FeaturedProRata"] = "FEATURED_PRO_RATA";
    ReclaimAlgorithmTypes["FeaturedProportions"] = "FEATURED_PROPORTIONS";
    ReclaimAlgorithmTypes["SelectedEqual"] = "SELECTED_EQUAL";
    ReclaimAlgorithmTypes["SelectedProRata"] = "SELECTED_PRO_RATA";
    ReclaimAlgorithmTypes["SelectedProportions"] = "SELECTED_PROPORTIONS";
})(ReclaimAlgorithmTypes = exports.ReclaimAlgorithmTypes || (exports.ReclaimAlgorithmTypes = {}));
var ReclaimSettingsStatus;
(function (ReclaimSettingsStatus) {
    ReclaimSettingsStatus["Off"] = "OFF";
    ReclaimSettingsStatus["On"] = "ON";
    ReclaimSettingsStatus["Unavailable"] = "UNAVAILABLE";
})(ReclaimSettingsStatus = exports.ReclaimSettingsStatus || (exports.ReclaimSettingsStatus = {}));
var ReferenceType;
(function (ReferenceType) {
    ReferenceType["Partner"] = "PARTNER";
    ReferenceType["Shopify"] = "SHOPIFY";
})(ReferenceType = exports.ReferenceType || (exports.ReferenceType = {}));
var SnapshotDataType;
(function (SnapshotDataType) {
    SnapshotDataType["AlexAndAniGivingTuesday2022"] = "ALEX_AND_ANI_GIVING_TUESDAY_2022";
    SnapshotDataType["AlalaGivingTuesday2022"] = "ALALA_GIVING_TUESDAY_2022";
    SnapshotDataType["GivingTuesday2022"] = "GIVING_TUESDAY_2022";
})(SnapshotDataType = exports.SnapshotDataType || (exports.SnapshotDataType = {}));
var SubscriptionCanceledReasonEnum;
(function (SubscriptionCanceledReasonEnum) {
    SubscriptionCanceledReasonEnum["ClientCanceled"] = "CLIENT_CANCELED";
    SubscriptionCanceledReasonEnum["ClientChanged"] = "CLIENT_CHANGED";
    SubscriptionCanceledReasonEnum["ClientUninstalled"] = "CLIENT_UNINSTALLED";
    SubscriptionCanceledReasonEnum["FreeTrialExpired"] = "FREE_TRIAL_EXPIRED";
    SubscriptionCanceledReasonEnum["GivzCanceled"] = "GIVZ_CANCELED";
})(SubscriptionCanceledReasonEnum = exports.SubscriptionCanceledReasonEnum || (exports.SubscriptionCanceledReasonEnum = {}));
var SubscriptionStatusEnum;
(function (SubscriptionStatusEnum) {
    SubscriptionStatusEnum["Active"] = "ACTIVE";
    SubscriptionStatusEnum["Canceled"] = "CANCELED";
    SubscriptionStatusEnum["Pending"] = "PENDING";
})(SubscriptionStatusEnum = exports.SubscriptionStatusEnum || (exports.SubscriptionStatusEnum = {}));
var SubscriptionSelectAdminDtoCanceledReasonEnum;
(function (SubscriptionSelectAdminDtoCanceledReasonEnum) {
    SubscriptionSelectAdminDtoCanceledReasonEnum["ClientCanceled"] = "CLIENT_CANCELED";
    SubscriptionSelectAdminDtoCanceledReasonEnum["ClientChanged"] = "CLIENT_CHANGED";
    SubscriptionSelectAdminDtoCanceledReasonEnum["ClientUninstalled"] = "CLIENT_UNINSTALLED";
    SubscriptionSelectAdminDtoCanceledReasonEnum["FreeTrialExpired"] = "FREE_TRIAL_EXPIRED";
    SubscriptionSelectAdminDtoCanceledReasonEnum["GivzCanceled"] = "GIVZ_CANCELED";
})(SubscriptionSelectAdminDtoCanceledReasonEnum = exports.SubscriptionSelectAdminDtoCanceledReasonEnum || (exports.SubscriptionSelectAdminDtoCanceledReasonEnum = {}));
var SubscriptionSelectAdminDtoStatusEnum;
(function (SubscriptionSelectAdminDtoStatusEnum) {
    SubscriptionSelectAdminDtoStatusEnum["Active"] = "ACTIVE";
    SubscriptionSelectAdminDtoStatusEnum["Canceled"] = "CANCELED";
    SubscriptionSelectAdminDtoStatusEnum["Pending"] = "PENDING";
})(SubscriptionSelectAdminDtoStatusEnum = exports.SubscriptionSelectAdminDtoStatusEnum || (exports.SubscriptionSelectAdminDtoStatusEnum = {}));
var WidgetInitialRender;
(function (WidgetInitialRender) {
    WidgetInitialRender["Inline"] = "INLINE";
    WidgetInitialRender["Modal"] = "MODAL";
    WidgetInitialRender["Hidden"] = "HIDDEN";
})(WidgetInitialRender = exports.WidgetInitialRender || (exports.WidgetInitialRender = {}));
var WidgetStatus;
(function (WidgetStatus) {
    WidgetStatus["Installed"] = "INSTALLED";
    WidgetStatus["NotInstalled"] = "NOT_INSTALLED";
})(WidgetStatus = exports.WidgetStatus || (exports.WidgetStatus = {}));
var AccountsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        accountsControllerGetCurrentAccount: function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/accounts/current";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        accountsControllerGetCurrentShopifyAppReview: function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/accounts/current/shopifyAppReview";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        accountsControllerGetCurrentUsage: function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/accounts/current/usage";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        accountsControllerUpdateCurrentAccount: function (accountUpdate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('accountsControllerUpdateCurrentAccount', 'accountUpdate', accountUpdate);
                            localVarPath = "/core/v1/accounts/current";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountUpdate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AccountsApiAxiosParamCreator = AccountsApiAxiosParamCreator;
var AccountsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AccountsApiAxiosParamCreator)(configuration);
    return {
        accountsControllerGetCurrentAccount: function (options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.accountsControllerGetCurrentAccount(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        accountsControllerGetCurrentShopifyAppReview: function (options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.accountsControllerGetCurrentShopifyAppReview(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        accountsControllerGetCurrentUsage: function (options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.accountsControllerGetCurrentUsage(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        accountsControllerUpdateCurrentAccount: function (accountUpdate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.accountsControllerUpdateCurrentAccount(accountUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AccountsApiFp = AccountsApiFp;
var AccountsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AccountsApiFp)(configuration);
    return {
        accountsControllerGetCurrentAccount: function (options) {
            return localVarFp
                .accountsControllerGetCurrentAccount(options)
                .then(function (request) { return request(axios, basePath); });
        },
        accountsControllerGetCurrentShopifyAppReview: function (options) {
            return localVarFp
                .accountsControllerGetCurrentShopifyAppReview(options)
                .then(function (request) { return request(axios, basePath); });
        },
        accountsControllerGetCurrentUsage: function (options) {
            return localVarFp
                .accountsControllerGetCurrentUsage(options)
                .then(function (request) { return request(axios, basePath); });
        },
        accountsControllerUpdateCurrentAccount: function (accountUpdate, options) {
            return localVarFp
                .accountsControllerUpdateCurrentAccount(accountUpdate, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AccountsApiFactory = AccountsApiFactory;
var AccountsApi = (function (_super) {
    tslib_1.__extends(AccountsApi, _super);
    function AccountsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountsApi.prototype.accountsControllerGetCurrentAccount = function (options) {
        var _this = this;
        return (0, exports.AccountsApiFp)(this.configuration)
            .accountsControllerGetCurrentAccount(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AccountsApi.prototype.accountsControllerGetCurrentShopifyAppReview = function (options) {
        var _this = this;
        return (0, exports.AccountsApiFp)(this.configuration)
            .accountsControllerGetCurrentShopifyAppReview(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AccountsApi.prototype.accountsControllerGetCurrentUsage = function (options) {
        var _this = this;
        return (0, exports.AccountsApiFp)(this.configuration)
            .accountsControllerGetCurrentUsage(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AccountsApi.prototype.accountsControllerUpdateCurrentAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountsApiFp)(this.configuration)
            .accountsControllerUpdateCurrentAccount(requestParameters.accountUpdate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AccountsApi;
}(base_1.BaseAPI));
exports.AccountsApi = AccountsApi;
var AdminApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        adminAccessTokensControllerCreateAdminAccessToken: function (adminAccessTokenCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminAccessTokensControllerCreateAdminAccessToken', 'adminAccessTokenCreate', adminAccessTokenCreate);
                            localVarPath = "/core/v1/admin/accessTokens/admin";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminAccessTokenCreate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminAccessTokensControllerCreatePartnerAccessToken: function (partnerAccessTokenCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminAccessTokensControllerCreatePartnerAccessToken', 'partnerAccessTokenCreate', partnerAccessTokenCreate);
                            localVarPath = "/core/v1/admin/accessTokens/partner";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(partnerAccessTokenCreate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminAccessTokensControllerCreateSuperAdminAccessToken: function (superAdminAccessTokenCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('adminAccessTokensControllerCreateSuperAdminAccessToken', 'superAdminAccessTokenCreate', superAdminAccessTokenCreate);
                    localVarPath = "/core/v1/admin/accessTokens/superAdmin";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(superAdminAccessTokenCreate, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        adminAccountsControllerCreateAccountCredit: function (adminAccountCreditCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminAccountsControllerCreateAccountCredit', 'adminAccountCreditCreate', adminAccountCreditCreate);
                            localVarPath = "/core/v1/admin/accounts/accountCredits";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminAccountCreditCreate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminAccountsControllerCreateHostedAccount: function (hostedAccountCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminAccountsControllerCreateHostedAccount', 'hostedAccountCreate', hostedAccountCreate);
                            localVarPath = "/core/v1/admin/accounts/hosted";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hostedAccountCreate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminAccountsControllerUpdateAccount: function (id, adminAccountUpdate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminAccountsControllerUpdateAccount', 'id', id);
                            (0, common_1.assertParamExists)('adminAccountsControllerUpdateAccount', 'adminAccountUpdate', adminAccountUpdate);
                            localVarPath = "/core/v1/admin/accounts/{id}".replace("{".concat('id', "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminAccountUpdate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminAccountsControllerUpdateHostedAccount: function (id, hostedAccountUpdate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminAccountsControllerUpdateHostedAccount', 'id', id);
                            (0, common_1.assertParamExists)('adminAccountsControllerUpdateHostedAccount', 'hostedAccountUpdate', hostedAccountUpdate);
                            localVarPath = "/core/v1/admin/accounts/hosted/{id}".replace("{".concat('id', "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hostedAccountUpdate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminCampaignsControllerCreateHostedCampaign: function (adminHostedCampaignCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminCampaignsControllerCreateHostedCampaign', 'adminHostedCampaignCreate', adminHostedCampaignCreate);
                            localVarPath = "/core/v1/admin/campaigns";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminHostedCampaignCreate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminCampaignsControllerUpdateHostedCampaign: function (id, adminHostedCampaignUpdate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminCampaignsControllerUpdateHostedCampaign', 'id', id);
                            (0, common_1.assertParamExists)('adminCampaignsControllerUpdateHostedCampaign', 'adminHostedCampaignUpdate', adminHostedCampaignUpdate);
                            localVarPath = "/core/v1/admin/campaigns/{id}".replace("{".concat('id', "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminHostedCampaignUpdate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminCollectionsControllerCreateCollection: function (adminCollectionCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminCollectionsControllerCreateCollection', 'adminCollectionCreate', adminCollectionCreate);
                            localVarPath = "/core/v1/admin/collections";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminCollectionCreate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminCollectionsControllerUpdateCollection: function (id, adminCollectionUpdate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminCollectionsControllerUpdateCollection', 'id', id);
                            (0, common_1.assertParamExists)('adminCollectionsControllerUpdateCollection', 'adminCollectionUpdate', adminCollectionUpdate);
                            localVarPath = "/core/v1/admin/collections/{id}".replace("{".concat('id', "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminCollectionUpdate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminDonationCreditsControllerCreateDonationCredits: function (adminDonationCreditCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminDonationCreditsControllerCreateDonationCredits', 'adminDonationCreditCreate', adminDonationCreditCreate);
                            localVarPath = "/core/v1/admin/donationCredits";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminDonationCreditCreate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminFreeTrialsControllerEndFreeTrial: function (id, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminFreeTrialsControllerEndFreeTrial', 'id', id);
                            localVarPath = "/core/v1/admin/freeTrials/{id}/end".replace("{".concat('id', "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminFreeTrialsControllerUpdateFreeTrial: function (id, adminFreeTrialUpdateDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminFreeTrialsControllerUpdateFreeTrial', 'id', id);
                            (0, common_1.assertParamExists)('adminFreeTrialsControllerUpdateFreeTrial', 'adminFreeTrialUpdateDto', adminFreeTrialUpdateDto);
                            localVarPath = "/core/v1/admin/freeTrials/{id}".replace("{".concat('id', "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminFreeTrialUpdateDto, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminInvoicesControllerCreateInvoices: function (invoicesAdminCreateDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminInvoicesControllerCreateInvoices', 'invoicesAdminCreateDto', invoicesAdminCreateDto);
                            localVarPath = "/core/v1/admin/invoices";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(invoicesAdminCreateDto, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminInvoicesControllerMarkInvoiceAsPaid: function (invoiceId, invoiceMarkAsPaidDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminInvoicesControllerMarkInvoiceAsPaid', 'invoiceId', invoiceId);
                            (0, common_1.assertParamExists)('adminInvoicesControllerMarkInvoiceAsPaid', 'invoiceMarkAsPaidDto', invoiceMarkAsPaidDto);
                            localVarPath = "/core/v1/admin/invoices/{invoiceId}/markAsPaid".replace("{".concat('invoiceId', "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(invoiceMarkAsPaidDto, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminJobsControllerBackfillMissingReminders: function (adminBackfillMissingRemindersParamsDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminJobsControllerBackfillMissingReminders', 'adminBackfillMissingRemindersParamsDto', adminBackfillMissingRemindersParamsDto);
                            localVarPath = "/core/v1/admin/jobs/backfillMissingReminders";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminBackfillMissingRemindersParamsDto, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminJobsControllerBackfillShopifyOrders: function (adminBackfillShopifyOrdersParams, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminJobsControllerBackfillShopifyOrders', 'adminBackfillShopifyOrdersParams', adminBackfillShopifyOrdersParams);
                            localVarPath = "/core/v1/admin/jobs/backfillShopifyOrders";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminBackfillShopifyOrdersParams, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminJobsControllerBackfillShopifyPerformance: function (adminBackfillShopifyPerformanceParams, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminJobsControllerBackfillShopifyPerformance', 'adminBackfillShopifyPerformanceParams', adminBackfillShopifyPerformanceParams);
                            localVarPath = "/core/v1/admin/jobs/backfillShopifyPerformance";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminBackfillShopifyPerformanceParams, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminJobsControllerCreateDisbursements: function (adminDisbursementParams, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminJobsControllerCreateDisbursements', 'adminDisbursementParams', adminDisbursementParams);
                            localVarPath = "/core/v1/admin/jobs/createDisbursements";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminDisbursementParams, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminJobsControllerGetLighthouseScore: function (accountId, url, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/admin/jobs/getLighthouseScore";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (accountId !== undefined) {
                                localVarQueryParameter['accountId'] = accountId;
                            }
                            if (url !== undefined) {
                                localVarQueryParameter['url'] = url;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminJobsControllerOptOutConsumer: function (adminOptOutConsumerParams, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminJobsControllerOptOutConsumer', 'adminOptOutConsumerParams', adminOptOutConsumerParams);
                            localVarPath = "/core/v1/admin/jobs/optOutConsumer";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminOptOutConsumerParams, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminJobsControllerReclaimDonationCredits: function (adminReclaimDonationCreditsParams, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminJobsControllerReclaimDonationCredits', 'adminReclaimDonationCreditsParams', adminReclaimDonationCreditsParams);
                            localVarPath = "/core/v1/admin/jobs/reclaimDonationCredits";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminReclaimDonationCreditsParams, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminJobsControllerRedactConsumer: function (adminRedactConsumerParams, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminJobsControllerRedactConsumer', 'adminRedactConsumerParams', adminRedactConsumerParams);
                            localVarPath = "/core/v1/admin/jobs/redactConsumer";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminRedactConsumerParams, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminJobsControllerSyncAccounts: function (adminSyncAccountsParamsDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminJobsControllerSyncAccounts', 'adminSyncAccountsParamsDto', adminSyncAccountsParamsDto);
                            localVarPath = "/core/v1/admin/jobs/syncAccounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminSyncAccountsParamsDto, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminJobsControllerSyncAmplitudeAccounts: function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/admin/jobs/syncAmplitudeAccounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminJobsControllerSyncShopifyShops: function (adminSyncShopifyShopsParamsDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminJobsControllerSyncShopifyShops', 'adminSyncShopifyShopsParamsDto', adminSyncShopifyShopsParamsDto);
                            localVarPath = "/core/v1/admin/jobs/syncShopifyShops";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminSyncShopifyShopsParamsDto, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminOrganizationsControllerCreateOrganization: function (adminOrganizationCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminOrganizationsControllerCreateOrganization', 'adminOrganizationCreate', adminOrganizationCreate);
                            localVarPath = "/core/v1/admin/organizations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminOrganizationCreate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminOrganizationsControllerSearchOrganizations: function (paypalId, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/admin/organizations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (paypalId) {
                                localVarQueryParameter['paypalId'] = paypalId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminOrganizationsControllerUpdateOrganization: function (id, adminOrganizationUpdate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminOrganizationsControllerUpdateOrganization', 'id', id);
                            (0, common_1.assertParamExists)('adminOrganizationsControllerUpdateOrganization', 'adminOrganizationUpdate', adminOrganizationUpdate);
                            localVarPath = "/core/v1/admin/organizations/{id}".replace("{".concat('id', "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminOrganizationUpdate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminStatusControllerGetFeaturesSummary: function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/admin/status";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminSubscriptionsControllerCreateHostedSubscription: function (subscriptionAdminCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminSubscriptionsControllerCreateHostedSubscription', 'subscriptionAdminCreate', subscriptionAdminCreate);
                            localVarPath = "/core/v1/admin/subscriptions/hosted";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(subscriptionAdminCreate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminUtilitiesControllerForceError: function (statusCode, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminUtilitiesControllerForceError', 'statusCode', statusCode);
                            localVarPath = "/core/v1/admin/utilities/forceError/{statusCode}".replace("{".concat('statusCode', "}"), encodeURIComponent(String(statusCode)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        adminUtilitiesControllerHubspotSync: function (accountId, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('adminUtilitiesControllerHubspotSync', 'accountId', accountId);
                            localVarPath = "/core/v1/admin/utilities/hubspot/sync/{accountId}".replace("{".concat('accountId', "}"), encodeURIComponent(String(accountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AdminApiAxiosParamCreator = AdminApiAxiosParamCreator;
var AdminApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AdminApiAxiosParamCreator)(configuration);
    return {
        adminAccessTokensControllerCreateAdminAccessToken: function (adminAccessTokenCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminAccessTokensControllerCreateAdminAccessToken(adminAccessTokenCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminAccessTokensControllerCreatePartnerAccessToken: function (partnerAccessTokenCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminAccessTokensControllerCreatePartnerAccessToken(partnerAccessTokenCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminAccessTokensControllerCreateSuperAdminAccessToken: function (superAdminAccessTokenCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminAccessTokensControllerCreateSuperAdminAccessToken(superAdminAccessTokenCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminAccountsControllerCreateAccountCredit: function (adminAccountCreditCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminAccountsControllerCreateAccountCredit(adminAccountCreditCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminAccountsControllerCreateHostedAccount: function (hostedAccountCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminAccountsControllerCreateHostedAccount(hostedAccountCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminAccountsControllerUpdateAccount: function (id, adminAccountUpdate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminAccountsControllerUpdateAccount(id, adminAccountUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminAccountsControllerUpdateHostedAccount: function (id, hostedAccountUpdate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminAccountsControllerUpdateHostedAccount(id, hostedAccountUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminCampaignsControllerCreateHostedCampaign: function (adminHostedCampaignCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminCampaignsControllerCreateHostedCampaign(adminHostedCampaignCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminCampaignsControllerUpdateHostedCampaign: function (id, adminHostedCampaignUpdate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminCampaignsControllerUpdateHostedCampaign(id, adminHostedCampaignUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminCollectionsControllerCreateCollection: function (adminCollectionCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminCollectionsControllerCreateCollection(adminCollectionCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminCollectionsControllerUpdateCollection: function (id, adminCollectionUpdate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminCollectionsControllerUpdateCollection(id, adminCollectionUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminDonationCreditsControllerCreateDonationCredits: function (adminDonationCreditCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminDonationCreditsControllerCreateDonationCredits(adminDonationCreditCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminFreeTrialsControllerEndFreeTrial: function (id, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminFreeTrialsControllerEndFreeTrial(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminFreeTrialsControllerUpdateFreeTrial: function (id, adminFreeTrialUpdateDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminFreeTrialsControllerUpdateFreeTrial(id, adminFreeTrialUpdateDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminInvoicesControllerCreateInvoices: function (invoicesAdminCreateDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminInvoicesControllerCreateInvoices(invoicesAdminCreateDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminInvoicesControllerMarkInvoiceAsPaid: function (invoiceId, invoiceMarkAsPaidDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminInvoicesControllerMarkInvoiceAsPaid(invoiceId, invoiceMarkAsPaidDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminJobsControllerBackfillMissingReminders: function (adminBackfillMissingRemindersParamsDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminJobsControllerBackfillMissingReminders(adminBackfillMissingRemindersParamsDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminJobsControllerBackfillShopifyOrders: function (adminBackfillShopifyOrdersParams, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminJobsControllerBackfillShopifyOrders(adminBackfillShopifyOrdersParams, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminJobsControllerBackfillShopifyPerformance: function (adminBackfillShopifyPerformanceParams, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminJobsControllerBackfillShopifyPerformance(adminBackfillShopifyPerformanceParams, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminJobsControllerCreateDisbursements: function (adminDisbursementParams, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminJobsControllerCreateDisbursements(adminDisbursementParams, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminJobsControllerGetLighthouseScore: function (accountId, url, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminJobsControllerGetLighthouseScore(accountId, url, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminJobsControllerOptOutConsumer: function (adminOptOutConsumerParams, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminJobsControllerOptOutConsumer(adminOptOutConsumerParams, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminJobsControllerReclaimDonationCredits: function (adminReclaimDonationCreditsParams, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminJobsControllerReclaimDonationCredits(adminReclaimDonationCreditsParams, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminJobsControllerRedactConsumer: function (adminRedactConsumerParams, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminJobsControllerRedactConsumer(adminRedactConsumerParams, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminJobsControllerSyncAccounts: function (adminSyncAccountsParamsDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminJobsControllerSyncAccounts(adminSyncAccountsParamsDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminJobsControllerSyncAmplitudeAccounts: function (options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminJobsControllerSyncAmplitudeAccounts(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminJobsControllerSyncShopifyShops: function (adminSyncShopifyShopsParamsDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminJobsControllerSyncShopifyShops(adminSyncShopifyShopsParamsDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminOrganizationsControllerCreateOrganization: function (adminOrganizationCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminOrganizationsControllerCreateOrganization(adminOrganizationCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminOrganizationsControllerSearchOrganizations: function (paypalId, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminOrganizationsControllerSearchOrganizations(paypalId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminOrganizationsControllerUpdateOrganization: function (id, adminOrganizationUpdate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminOrganizationsControllerUpdateOrganization(id, adminOrganizationUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminStatusControllerGetFeaturesSummary: function (options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminStatusControllerGetFeaturesSummary(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminSubscriptionsControllerCreateHostedSubscription: function (subscriptionAdminCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminSubscriptionsControllerCreateHostedSubscription(subscriptionAdminCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminUtilitiesControllerForceError: function (statusCode, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminUtilitiesControllerForceError(statusCode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminUtilitiesControllerHubspotSync: function (accountId, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminUtilitiesControllerHubspotSync(accountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AdminApiFp = AdminApiFp;
var AdminApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AdminApiFp)(configuration);
    return {
        adminAccessTokensControllerCreateAdminAccessToken: function (adminAccessTokenCreate, options) {
            return localVarFp
                .adminAccessTokensControllerCreateAdminAccessToken(adminAccessTokenCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminAccessTokensControllerCreatePartnerAccessToken: function (partnerAccessTokenCreate, options) {
            return localVarFp
                .adminAccessTokensControllerCreatePartnerAccessToken(partnerAccessTokenCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminAccessTokensControllerCreateSuperAdminAccessToken: function (superAdminAccessTokenCreate, options) {
            return localVarFp
                .adminAccessTokensControllerCreateSuperAdminAccessToken(superAdminAccessTokenCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminAccountsControllerCreateAccountCredit: function (adminAccountCreditCreate, options) {
            return localVarFp
                .adminAccountsControllerCreateAccountCredit(adminAccountCreditCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminAccountsControllerCreateHostedAccount: function (hostedAccountCreate, options) {
            return localVarFp
                .adminAccountsControllerCreateHostedAccount(hostedAccountCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminAccountsControllerUpdateAccount: function (id, adminAccountUpdate, options) {
            return localVarFp
                .adminAccountsControllerUpdateAccount(id, adminAccountUpdate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminAccountsControllerUpdateHostedAccount: function (id, hostedAccountUpdate, options) {
            return localVarFp
                .adminAccountsControllerUpdateHostedAccount(id, hostedAccountUpdate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminCampaignsControllerCreateHostedCampaign: function (adminHostedCampaignCreate, options) {
            return localVarFp
                .adminCampaignsControllerCreateHostedCampaign(adminHostedCampaignCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminCampaignsControllerUpdateHostedCampaign: function (id, adminHostedCampaignUpdate, options) {
            return localVarFp
                .adminCampaignsControllerUpdateHostedCampaign(id, adminHostedCampaignUpdate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminCollectionsControllerCreateCollection: function (adminCollectionCreate, options) {
            return localVarFp
                .adminCollectionsControllerCreateCollection(adminCollectionCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminCollectionsControllerUpdateCollection: function (id, adminCollectionUpdate, options) {
            return localVarFp
                .adminCollectionsControllerUpdateCollection(id, adminCollectionUpdate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminDonationCreditsControllerCreateDonationCredits: function (adminDonationCreditCreate, options) {
            return localVarFp
                .adminDonationCreditsControllerCreateDonationCredits(adminDonationCreditCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminFreeTrialsControllerEndFreeTrial: function (id, options) {
            return localVarFp
                .adminFreeTrialsControllerEndFreeTrial(id, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminFreeTrialsControllerUpdateFreeTrial: function (id, adminFreeTrialUpdateDto, options) {
            return localVarFp
                .adminFreeTrialsControllerUpdateFreeTrial(id, adminFreeTrialUpdateDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminInvoicesControllerCreateInvoices: function (invoicesAdminCreateDto, options) {
            return localVarFp
                .adminInvoicesControllerCreateInvoices(invoicesAdminCreateDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminInvoicesControllerMarkInvoiceAsPaid: function (invoiceId, invoiceMarkAsPaidDto, options) {
            return localVarFp
                .adminInvoicesControllerMarkInvoiceAsPaid(invoiceId, invoiceMarkAsPaidDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminJobsControllerBackfillMissingReminders: function (adminBackfillMissingRemindersParamsDto, options) {
            return localVarFp
                .adminJobsControllerBackfillMissingReminders(adminBackfillMissingRemindersParamsDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminJobsControllerBackfillShopifyOrders: function (adminBackfillShopifyOrdersParams, options) {
            return localVarFp
                .adminJobsControllerBackfillShopifyOrders(adminBackfillShopifyOrdersParams, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminJobsControllerBackfillShopifyPerformance: function (adminBackfillShopifyPerformanceParams, options) {
            return localVarFp
                .adminJobsControllerBackfillShopifyPerformance(adminBackfillShopifyPerformanceParams, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminJobsControllerCreateDisbursements: function (adminDisbursementParams, options) {
            return localVarFp
                .adminJobsControllerCreateDisbursements(adminDisbursementParams, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminJobsControllerGetLighthouseScore: function (accountId, url, options) {
            return localVarFp
                .adminJobsControllerGetLighthouseScore(accountId, url, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminJobsControllerOptOutConsumer: function (adminOptOutConsumerParams, options) {
            return localVarFp
                .adminJobsControllerOptOutConsumer(adminOptOutConsumerParams, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminJobsControllerReclaimDonationCredits: function (adminReclaimDonationCreditsParams, options) {
            return localVarFp
                .adminJobsControllerReclaimDonationCredits(adminReclaimDonationCreditsParams, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminJobsControllerRedactConsumer: function (adminRedactConsumerParams, options) {
            return localVarFp
                .adminJobsControllerRedactConsumer(adminRedactConsumerParams, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminJobsControllerSyncAccounts: function (adminSyncAccountsParamsDto, options) {
            return localVarFp
                .adminJobsControllerSyncAccounts(adminSyncAccountsParamsDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminJobsControllerSyncAmplitudeAccounts: function (options) {
            return localVarFp
                .adminJobsControllerSyncAmplitudeAccounts(options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminJobsControllerSyncShopifyShops: function (adminSyncShopifyShopsParamsDto, options) {
            return localVarFp
                .adminJobsControllerSyncShopifyShops(adminSyncShopifyShopsParamsDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminOrganizationsControllerCreateOrganization: function (adminOrganizationCreate, options) {
            return localVarFp
                .adminOrganizationsControllerCreateOrganization(adminOrganizationCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminOrganizationsControllerSearchOrganizations: function (paypalId, options) {
            return localVarFp
                .adminOrganizationsControllerSearchOrganizations(paypalId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminOrganizationsControllerUpdateOrganization: function (id, adminOrganizationUpdate, options) {
            return localVarFp
                .adminOrganizationsControllerUpdateOrganization(id, adminOrganizationUpdate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminStatusControllerGetFeaturesSummary: function (options) {
            return localVarFp
                .adminStatusControllerGetFeaturesSummary(options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminSubscriptionsControllerCreateHostedSubscription: function (subscriptionAdminCreate, options) {
            return localVarFp
                .adminSubscriptionsControllerCreateHostedSubscription(subscriptionAdminCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminUtilitiesControllerForceError: function (statusCode, options) {
            return localVarFp
                .adminUtilitiesControllerForceError(statusCode, options)
                .then(function (request) { return request(axios, basePath); });
        },
        adminUtilitiesControllerHubspotSync: function (accountId, options) {
            return localVarFp
                .adminUtilitiesControllerHubspotSync(accountId, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AdminApiFactory = AdminApiFactory;
var AdminApi = (function (_super) {
    tslib_1.__extends(AdminApi, _super);
    function AdminApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdminApi.prototype.adminAccessTokensControllerCreateAdminAccessToken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminAccessTokensControllerCreateAdminAccessToken(requestParameters.adminAccessTokenCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminAccessTokensControllerCreatePartnerAccessToken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminAccessTokensControllerCreatePartnerAccessToken(requestParameters.partnerAccessTokenCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminAccessTokensControllerCreateSuperAdminAccessToken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminAccessTokensControllerCreateSuperAdminAccessToken(requestParameters.superAdminAccessTokenCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminAccountsControllerCreateAccountCredit = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminAccountsControllerCreateAccountCredit(requestParameters.adminAccountCreditCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminAccountsControllerCreateHostedAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminAccountsControllerCreateHostedAccount(requestParameters.hostedAccountCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminAccountsControllerUpdateAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminAccountsControllerUpdateAccount(requestParameters.id, requestParameters.adminAccountUpdate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminAccountsControllerUpdateHostedAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminAccountsControllerUpdateHostedAccount(requestParameters.id, requestParameters.hostedAccountUpdate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminCampaignsControllerCreateHostedCampaign = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminCampaignsControllerCreateHostedCampaign(requestParameters.adminHostedCampaignCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminCampaignsControllerUpdateHostedCampaign = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminCampaignsControllerUpdateHostedCampaign(requestParameters.id, requestParameters.adminHostedCampaignUpdate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminCollectionsControllerCreateCollection = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminCollectionsControllerCreateCollection(requestParameters.adminCollectionCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminCollectionsControllerUpdateCollection = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminCollectionsControllerUpdateCollection(requestParameters.id, requestParameters.adminCollectionUpdate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminDonationCreditsControllerCreateDonationCredits = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminDonationCreditsControllerCreateDonationCredits(requestParameters.adminDonationCreditCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminFreeTrialsControllerEndFreeTrial = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminFreeTrialsControllerEndFreeTrial(requestParameters.id, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminFreeTrialsControllerUpdateFreeTrial = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminFreeTrialsControllerUpdateFreeTrial(requestParameters.id, requestParameters.adminFreeTrialUpdateDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminInvoicesControllerCreateInvoices = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminInvoicesControllerCreateInvoices(requestParameters.invoicesAdminCreateDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminInvoicesControllerMarkInvoiceAsPaid = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminInvoicesControllerMarkInvoiceAsPaid(requestParameters.invoiceId, requestParameters.invoiceMarkAsPaidDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminJobsControllerBackfillMissingReminders = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminJobsControllerBackfillMissingReminders(requestParameters.adminBackfillMissingRemindersParamsDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminJobsControllerBackfillShopifyOrders = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminJobsControllerBackfillShopifyOrders(requestParameters.adminBackfillShopifyOrdersParams, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminJobsControllerBackfillShopifyPerformance = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminJobsControllerBackfillShopifyPerformance(requestParameters.adminBackfillShopifyPerformanceParams, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminJobsControllerCreateDisbursements = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminJobsControllerCreateDisbursements(requestParameters.adminDisbursementParams, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminJobsControllerGetLighthouseScore = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AdminApiFp)(this.configuration)
            .adminJobsControllerGetLighthouseScore(requestParameters.accountId, requestParameters.url, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminJobsControllerOptOutConsumer = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminJobsControllerOptOutConsumer(requestParameters.adminOptOutConsumerParams, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminJobsControllerReclaimDonationCredits = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminJobsControllerReclaimDonationCredits(requestParameters.adminReclaimDonationCreditsParams, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminJobsControllerRedactConsumer = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminJobsControllerRedactConsumer(requestParameters.adminRedactConsumerParams, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminJobsControllerSyncAccounts = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminJobsControllerSyncAccounts(requestParameters.adminSyncAccountsParamsDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminJobsControllerSyncAmplitudeAccounts = function (options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminJobsControllerSyncAmplitudeAccounts(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminJobsControllerSyncShopifyShops = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminJobsControllerSyncShopifyShops(requestParameters.adminSyncShopifyShopsParamsDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminOrganizationsControllerCreateOrganization = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminOrganizationsControllerCreateOrganization(requestParameters.adminOrganizationCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminOrganizationsControllerSearchOrganizations = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AdminApiFp)(this.configuration)
            .adminOrganizationsControllerSearchOrganizations(requestParameters.paypalId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminOrganizationsControllerUpdateOrganization = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminOrganizationsControllerUpdateOrganization(requestParameters.id, requestParameters.adminOrganizationUpdate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminStatusControllerGetFeaturesSummary = function (options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminStatusControllerGetFeaturesSummary(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminSubscriptionsControllerCreateHostedSubscription = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminSubscriptionsControllerCreateHostedSubscription(requestParameters.subscriptionAdminCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminUtilitiesControllerForceError = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminUtilitiesControllerForceError(requestParameters.statusCode, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AdminApi.prototype.adminUtilitiesControllerHubspotSync = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration)
            .adminUtilitiesControllerHubspotSync(requestParameters.accountId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AdminApi;
}(base_1.BaseAPI));
exports.AdminApi = AdminApi;
var AuthApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        authControllerChangePassword: function (changePasswordDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('authControllerChangePassword', 'changePasswordDto', changePasswordDto);
                            localVarPath = "/core/v1/auth/changePassword";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changePasswordDto, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        authControllerForgotPassword: function (forgotPasswordDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('authControllerForgotPassword', 'forgotPasswordDto', forgotPasswordDto);
                    localVarPath = "/core/v1/auth/forgotPassword";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(forgotPasswordDto, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        authControllerLogin: function (loginDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('authControllerLogin', 'loginDto', loginDto);
                    localVarPath = "/core/v1/auth/login";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loginDto, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        authControllerResetPassword: function (resetPasswordDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('authControllerResetPassword', 'resetPasswordDto', resetPasswordDto);
                    localVarPath = "/core/v1/auth/resetPassword";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(resetPasswordDto, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        authControllerSignup: function (signupDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('authControllerSignup', 'signupDto', signupDto);
                    localVarPath = "/core/v1/auth/signup";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(signupDto, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AuthApiAxiosParamCreator = AuthApiAxiosParamCreator;
var AuthApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AuthApiAxiosParamCreator)(configuration);
    return {
        authControllerChangePassword: function (changePasswordDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.authControllerChangePassword(changePasswordDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        authControllerForgotPassword: function (forgotPasswordDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.authControllerForgotPassword(forgotPasswordDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        authControllerLogin: function (loginDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.authControllerLogin(loginDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        authControllerResetPassword: function (resetPasswordDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.authControllerResetPassword(resetPasswordDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        authControllerSignup: function (signupDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.authControllerSignup(signupDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AuthApiFp = AuthApiFp;
var AuthApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AuthApiFp)(configuration);
    return {
        authControllerChangePassword: function (changePasswordDto, options) {
            return localVarFp
                .authControllerChangePassword(changePasswordDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        authControllerForgotPassword: function (forgotPasswordDto, options) {
            return localVarFp
                .authControllerForgotPassword(forgotPasswordDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        authControllerLogin: function (loginDto, options) {
            return localVarFp
                .authControllerLogin(loginDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        authControllerResetPassword: function (resetPasswordDto, options) {
            return localVarFp
                .authControllerResetPassword(resetPasswordDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        authControllerSignup: function (signupDto, options) {
            return localVarFp
                .authControllerSignup(signupDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AuthApiFactory = AuthApiFactory;
var AuthApi = (function (_super) {
    tslib_1.__extends(AuthApi, _super);
    function AuthApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthApi.prototype.authControllerChangePassword = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration)
            .authControllerChangePassword(requestParameters.changePasswordDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AuthApi.prototype.authControllerForgotPassword = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration)
            .authControllerForgotPassword(requestParameters.forgotPasswordDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AuthApi.prototype.authControllerLogin = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration)
            .authControllerLogin(requestParameters.loginDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AuthApi.prototype.authControllerResetPassword = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration)
            .authControllerResetPassword(requestParameters.resetPasswordDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    AuthApi.prototype.authControllerSignup = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthApiFp)(this.configuration)
            .authControllerSignup(requestParameters.signupDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AuthApi;
}(base_1.BaseAPI));
exports.AuthApi = AuthApi;
var CampaignsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        campaignsControllerActivateCampaign: function (gid, body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('campaignsControllerActivateCampaign', 'gid', gid);
                            (0, common_1.assertParamExists)('campaignsControllerActivateCampaign', 'body', body);
                            localVarPath = "/core/v1/campaigns/{gid}/activate".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        campaignsControllerArchiveCampaign: function (gid, body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('campaignsControllerArchiveCampaign', 'gid', gid);
                            (0, common_1.assertParamExists)('campaignsControllerArchiveCampaign', 'body', body);
                            localVarPath = "/core/v1/campaigns/{gid}/archive".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        campaignsControllerCampaignStats: function (gid, body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('campaignsControllerCampaignStats', 'gid', gid);
                            (0, common_1.assertParamExists)('campaignsControllerCampaignStats', 'body', body);
                            localVarPath = "/core/v1/campaigns/{gid}/stats".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        campaignsControllerChangeCampaignPriority: function (gid, campaignUpdatePriorityDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('campaignsControllerChangeCampaignPriority', 'gid', gid);
                            (0, common_1.assertParamExists)('campaignsControllerChangeCampaignPriority', 'campaignUpdatePriorityDto', campaignUpdatePriorityDto);
                            localVarPath = "/core/v1/campaigns/{gid}/priority".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(campaignUpdatePriorityDto, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        campaignsControllerCreateCampaign: function (body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('campaignsControllerCreateCampaign', 'body', body);
                            localVarPath = "/core/v1/campaigns";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        campaignsControllerDeactivateCampaign: function (gid, body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('campaignsControllerDeactivateCampaign', 'gid', gid);
                            (0, common_1.assertParamExists)('campaignsControllerDeactivateCampaign', 'body', body);
                            localVarPath = "/core/v1/campaigns/{gid}/deactivate".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        campaignsControllerGetAllCampaigns: function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/campaigns";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        campaignsControllerGetShopifyPrePurchasePromotionPreviewLinks: function (gid, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('campaignsControllerGetShopifyPrePurchasePromotionPreviewLinks', 'gid', gid);
                            localVarPath = "/core/v1/campaigns/{gid}/shopifyPrePurchasePromotionPreviewLinks".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        campaignsControllerUnarchiveCampaign: function (gid, body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('campaignsControllerUnarchiveCampaign', 'gid', gid);
                            (0, common_1.assertParamExists)('campaignsControllerUnarchiveCampaign', 'body', body);
                            localVarPath = "/core/v1/campaigns/{gid}/unarchive".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        campaignsControllerUpdateCampaign: function (gid, campaignUpdate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('campaignsControllerUpdateCampaign', 'gid', gid);
                            (0, common_1.assertParamExists)('campaignsControllerUpdateCampaign', 'campaignUpdate', campaignUpdate);
                            localVarPath = "/core/v1/campaigns/{gid}".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(campaignUpdate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CampaignsApiAxiosParamCreator = CampaignsApiAxiosParamCreator;
var CampaignsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CampaignsApiAxiosParamCreator)(configuration);
    return {
        campaignsControllerActivateCampaign: function (gid, body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.campaignsControllerActivateCampaign(gid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        campaignsControllerArchiveCampaign: function (gid, body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.campaignsControllerArchiveCampaign(gid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        campaignsControllerCampaignStats: function (gid, body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.campaignsControllerCampaignStats(gid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        campaignsControllerChangeCampaignPriority: function (gid, campaignUpdatePriorityDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.campaignsControllerChangeCampaignPriority(gid, campaignUpdatePriorityDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        campaignsControllerCreateCampaign: function (body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.campaignsControllerCreateCampaign(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        campaignsControllerDeactivateCampaign: function (gid, body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.campaignsControllerDeactivateCampaign(gid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        campaignsControllerGetAllCampaigns: function (options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.campaignsControllerGetAllCampaigns(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        campaignsControllerGetShopifyPrePurchasePromotionPreviewLinks: function (gid, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.campaignsControllerGetShopifyPrePurchasePromotionPreviewLinks(gid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        campaignsControllerUnarchiveCampaign: function (gid, body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.campaignsControllerUnarchiveCampaign(gid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        campaignsControllerUpdateCampaign: function (gid, campaignUpdate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.campaignsControllerUpdateCampaign(gid, campaignUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CampaignsApiFp = CampaignsApiFp;
var CampaignsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CampaignsApiFp)(configuration);
    return {
        campaignsControllerActivateCampaign: function (gid, body, options) {
            return localVarFp
                .campaignsControllerActivateCampaign(gid, body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        campaignsControllerArchiveCampaign: function (gid, body, options) {
            return localVarFp
                .campaignsControllerArchiveCampaign(gid, body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        campaignsControllerCampaignStats: function (gid, body, options) {
            return localVarFp
                .campaignsControllerCampaignStats(gid, body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        campaignsControllerChangeCampaignPriority: function (gid, campaignUpdatePriorityDto, options) {
            return localVarFp
                .campaignsControllerChangeCampaignPriority(gid, campaignUpdatePriorityDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        campaignsControllerCreateCampaign: function (body, options) {
            return localVarFp
                .campaignsControllerCreateCampaign(body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        campaignsControllerDeactivateCampaign: function (gid, body, options) {
            return localVarFp
                .campaignsControllerDeactivateCampaign(gid, body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        campaignsControllerGetAllCampaigns: function (options) {
            return localVarFp
                .campaignsControllerGetAllCampaigns(options)
                .then(function (request) { return request(axios, basePath); });
        },
        campaignsControllerGetShopifyPrePurchasePromotionPreviewLinks: function (gid, options) {
            return localVarFp
                .campaignsControllerGetShopifyPrePurchasePromotionPreviewLinks(gid, options)
                .then(function (request) { return request(axios, basePath); });
        },
        campaignsControllerUnarchiveCampaign: function (gid, body, options) {
            return localVarFp
                .campaignsControllerUnarchiveCampaign(gid, body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        campaignsControllerUpdateCampaign: function (gid, campaignUpdate, options) {
            return localVarFp
                .campaignsControllerUpdateCampaign(gid, campaignUpdate, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CampaignsApiFactory = CampaignsApiFactory;
var CampaignsApi = (function (_super) {
    tslib_1.__extends(CampaignsApi, _super);
    function CampaignsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CampaignsApi.prototype.campaignsControllerActivateCampaign = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CampaignsApiFp)(this.configuration)
            .campaignsControllerActivateCampaign(requestParameters.gid, requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    CampaignsApi.prototype.campaignsControllerArchiveCampaign = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CampaignsApiFp)(this.configuration)
            .campaignsControllerArchiveCampaign(requestParameters.gid, requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    CampaignsApi.prototype.campaignsControllerCampaignStats = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CampaignsApiFp)(this.configuration)
            .campaignsControllerCampaignStats(requestParameters.gid, requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    CampaignsApi.prototype.campaignsControllerChangeCampaignPriority = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CampaignsApiFp)(this.configuration)
            .campaignsControllerChangeCampaignPriority(requestParameters.gid, requestParameters.campaignUpdatePriorityDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    CampaignsApi.prototype.campaignsControllerCreateCampaign = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CampaignsApiFp)(this.configuration)
            .campaignsControllerCreateCampaign(requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    CampaignsApi.prototype.campaignsControllerDeactivateCampaign = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CampaignsApiFp)(this.configuration)
            .campaignsControllerDeactivateCampaign(requestParameters.gid, requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    CampaignsApi.prototype.campaignsControllerGetAllCampaigns = function (options) {
        var _this = this;
        return (0, exports.CampaignsApiFp)(this.configuration)
            .campaignsControllerGetAllCampaigns(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    CampaignsApi.prototype.campaignsControllerGetShopifyPrePurchasePromotionPreviewLinks = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CampaignsApiFp)(this.configuration)
            .campaignsControllerGetShopifyPrePurchasePromotionPreviewLinks(requestParameters.gid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    CampaignsApi.prototype.campaignsControllerUnarchiveCampaign = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CampaignsApiFp)(this.configuration)
            .campaignsControllerUnarchiveCampaign(requestParameters.gid, requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    CampaignsApi.prototype.campaignsControllerUpdateCampaign = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CampaignsApiFp)(this.configuration)
            .campaignsControllerUpdateCampaign(requestParameters.gid, requestParameters.campaignUpdate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CampaignsApi;
}(base_1.BaseAPI));
exports.CampaignsApi = CampaignsApi;
var CategoriesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        categoriesControllerGetAll: function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    localVarPath = "/core/v1/categories";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CategoriesApiAxiosParamCreator = CategoriesApiAxiosParamCreator;
var CategoriesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CategoriesApiAxiosParamCreator)(configuration);
    return {
        categoriesControllerGetAll: function (options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.categoriesControllerGetAll(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CategoriesApiFp = CategoriesApiFp;
var CategoriesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CategoriesApiFp)(configuration);
    return {
        categoriesControllerGetAll: function (options) {
            return localVarFp
                .categoriesControllerGetAll(options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CategoriesApiFactory = CategoriesApiFactory;
var CategoriesApi = (function (_super) {
    tslib_1.__extends(CategoriesApi, _super);
    function CategoriesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CategoriesApi.prototype.categoriesControllerGetAll = function (options) {
        var _this = this;
        return (0, exports.CategoriesApiFp)(this.configuration)
            .categoriesControllerGetAll(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CategoriesApi;
}(base_1.BaseAPI));
exports.CategoriesApi = CategoriesApi;
var CollectionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        collectionsControllerCreateHandpickedCollection: function (collectionCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('collectionsControllerCreateHandpickedCollection', 'collectionCreate', collectionCreate);
                            localVarPath = "/core/v1/collections";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(collectionCreate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        collectionsControllerGetCollection: function (gid, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('collectionsControllerGetCollection', 'gid', gid);
                    localVarPath = "/core/v1/collections/{gid}".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        collectionsControllerGetCuratedCollection: function (key, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('collectionsControllerGetCuratedCollection', 'key', key);
                    localVarPath = "/core/v1/collections/curated/{key}".replace("{".concat('key', "}"), encodeURIComponent(String(key)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        collectionsControllerUpdateHandpickedCollection: function (gid, collectionUpdate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('collectionsControllerUpdateHandpickedCollection', 'gid', gid);
                            (0, common_1.assertParamExists)('collectionsControllerUpdateHandpickedCollection', 'collectionUpdate', collectionUpdate);
                            localVarPath = "/core/v1/collections/{gid}".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(collectionUpdate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CollectionsApiAxiosParamCreator = CollectionsApiAxiosParamCreator;
var CollectionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CollectionsApiAxiosParamCreator)(configuration);
    return {
        collectionsControllerCreateHandpickedCollection: function (collectionCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.collectionsControllerCreateHandpickedCollection(collectionCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        collectionsControllerGetCollection: function (gid, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.collectionsControllerGetCollection(gid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        collectionsControllerGetCuratedCollection: function (key, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.collectionsControllerGetCuratedCollection(key, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        collectionsControllerUpdateHandpickedCollection: function (gid, collectionUpdate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.collectionsControllerUpdateHandpickedCollection(gid, collectionUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CollectionsApiFp = CollectionsApiFp;
var CollectionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CollectionsApiFp)(configuration);
    return {
        collectionsControllerCreateHandpickedCollection: function (collectionCreate, options) {
            return localVarFp
                .collectionsControllerCreateHandpickedCollection(collectionCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        collectionsControllerGetCollection: function (gid, options) {
            return localVarFp
                .collectionsControllerGetCollection(gid, options)
                .then(function (request) { return request(axios, basePath); });
        },
        collectionsControllerGetCuratedCollection: function (key, options) {
            return localVarFp
                .collectionsControllerGetCuratedCollection(key, options)
                .then(function (request) { return request(axios, basePath); });
        },
        collectionsControllerUpdateHandpickedCollection: function (gid, collectionUpdate, options) {
            return localVarFp
                .collectionsControllerUpdateHandpickedCollection(gid, collectionUpdate, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CollectionsApiFactory = CollectionsApiFactory;
var CollectionsApi = (function (_super) {
    tslib_1.__extends(CollectionsApi, _super);
    function CollectionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionsApi.prototype.collectionsControllerCreateHandpickedCollection = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CollectionsApiFp)(this.configuration)
            .collectionsControllerCreateHandpickedCollection(requestParameters.collectionCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    CollectionsApi.prototype.collectionsControllerGetCollection = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CollectionsApiFp)(this.configuration)
            .collectionsControllerGetCollection(requestParameters.gid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    CollectionsApi.prototype.collectionsControllerGetCuratedCollection = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CollectionsApiFp)(this.configuration)
            .collectionsControllerGetCuratedCollection(requestParameters.key, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    CollectionsApi.prototype.collectionsControllerUpdateHandpickedCollection = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CollectionsApiFp)(this.configuration)
            .collectionsControllerUpdateHandpickedCollection(requestParameters.gid, requestParameters.collectionUpdate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CollectionsApi;
}(base_1.BaseAPI));
exports.CollectionsApi = CollectionsApi;
var ConsumerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        consumerControllerUnsubscribe: function (unsubscribe, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('consumerControllerUnsubscribe', 'unsubscribe', unsubscribe);
                    localVarPath = "/core/v1/consumer/unsubscribe";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(unsubscribe, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ConsumerApiAxiosParamCreator = ConsumerApiAxiosParamCreator;
var ConsumerApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ConsumerApiAxiosParamCreator)(configuration);
    return {
        consumerControllerUnsubscribe: function (unsubscribe, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.consumerControllerUnsubscribe(unsubscribe, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ConsumerApiFp = ConsumerApiFp;
var ConsumerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ConsumerApiFp)(configuration);
    return {
        consumerControllerUnsubscribe: function (unsubscribe, options) {
            return localVarFp
                .consumerControllerUnsubscribe(unsubscribe, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ConsumerApiFactory = ConsumerApiFactory;
var ConsumerApi = (function (_super) {
    tslib_1.__extends(ConsumerApi, _super);
    function ConsumerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConsumerApi.prototype.consumerControllerUnsubscribe = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ConsumerApiFp)(this.configuration)
            .consumerControllerUnsubscribe(requestParameters.unsubscribe, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ConsumerApi;
}(base_1.BaseAPI));
exports.ConsumerApi = ConsumerApi;
var CouponCodesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        couponCodesControllerFindOne: function (id, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('couponCodesControllerFindOne', 'id', id);
                            localVarPath = "/core/v1/couponCodes/{id}".replace("{".concat('id', "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        couponCodesControllerSearchCouponCodes: function (page, pageSize, code, type, status, syncType, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/couponCodes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (code !== undefined) {
                                localVarQueryParameter['code'] = code;
                            }
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            if (status) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (syncType !== undefined) {
                                localVarQueryParameter['syncType'] = syncType;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CouponCodesApiAxiosParamCreator = CouponCodesApiAxiosParamCreator;
var CouponCodesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CouponCodesApiAxiosParamCreator)(configuration);
    return {
        couponCodesControllerFindOne: function (id, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.couponCodesControllerFindOne(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        couponCodesControllerSearchCouponCodes: function (page, pageSize, code, type, status, syncType, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.couponCodesControllerSearchCouponCodes(page, pageSize, code, type, status, syncType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CouponCodesApiFp = CouponCodesApiFp;
var CouponCodesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CouponCodesApiFp)(configuration);
    return {
        couponCodesControllerFindOne: function (id, options) {
            return localVarFp
                .couponCodesControllerFindOne(id, options)
                .then(function (request) { return request(axios, basePath); });
        },
        couponCodesControllerSearchCouponCodes: function (page, pageSize, code, type, status, syncType, options) {
            return localVarFp
                .couponCodesControllerSearchCouponCodes(page, pageSize, code, type, status, syncType, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CouponCodesApiFactory = CouponCodesApiFactory;
var CouponCodesApi = (function (_super) {
    tslib_1.__extends(CouponCodesApi, _super);
    function CouponCodesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CouponCodesApi.prototype.couponCodesControllerFindOne = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CouponCodesApiFp)(this.configuration)
            .couponCodesControllerFindOne(requestParameters.id, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    CouponCodesApi.prototype.couponCodesControllerSearchCouponCodes = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.CouponCodesApiFp)(this.configuration)
            .couponCodesControllerSearchCouponCodes(requestParameters.page, requestParameters.pageSize, requestParameters.code, requestParameters.type, requestParameters.status, requestParameters.syncType, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CouponCodesApi;
}(base_1.BaseAPI));
exports.CouponCodesApi = CouponCodesApi;
var DonationCreditsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        donationCreditsControllerCreateDonationCredit: function (givzDeviceId, donationCreditCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('donationCreditsControllerCreateDonationCredit', 'givzDeviceId', givzDeviceId);
                    (0, common_1.assertParamExists)('donationCreditsControllerCreateDonationCredit', 'donationCreditCreate', donationCreditCreate);
                    localVarPath = "/core/v1/donationCredits";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (givzDeviceId !== undefined && givzDeviceId !== null) {
                        localVarHeaderParameter['givz_device_id'] = String(givzDeviceId);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(donationCreditCreate, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        donationCreditsControllerGetDonationCreditFromToken: function (token, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('donationCreditsControllerGetDonationCreditFromToken', 'token', token);
                    localVarPath = "/core/v1/donationCredits/{token}".replace("{".concat('token', "}"), encodeURIComponent(String(token)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        donationCreditsControllerGetPreviewDonationCredit: function (donationCreditCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('donationCreditsControllerGetPreviewDonationCredit', 'donationCreditCreate', donationCreditCreate);
                    localVarPath = "/core/v1/donationCredits/preview";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(donationCreditCreate, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DonationCreditsApiAxiosParamCreator = DonationCreditsApiAxiosParamCreator;
var DonationCreditsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DonationCreditsApiAxiosParamCreator)(configuration);
    return {
        donationCreditsControllerCreateDonationCredit: function (givzDeviceId, donationCreditCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.donationCreditsControllerCreateDonationCredit(givzDeviceId, donationCreditCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        donationCreditsControllerGetDonationCreditFromToken: function (token, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.donationCreditsControllerGetDonationCreditFromToken(token, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        donationCreditsControllerGetPreviewDonationCredit: function (donationCreditCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.donationCreditsControllerGetPreviewDonationCredit(donationCreditCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DonationCreditsApiFp = DonationCreditsApiFp;
var DonationCreditsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DonationCreditsApiFp)(configuration);
    return {
        donationCreditsControllerCreateDonationCredit: function (givzDeviceId, donationCreditCreate, options) {
            return localVarFp
                .donationCreditsControllerCreateDonationCredit(givzDeviceId, donationCreditCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        donationCreditsControllerGetDonationCreditFromToken: function (token, options) {
            return localVarFp
                .donationCreditsControllerGetDonationCreditFromToken(token, options)
                .then(function (request) { return request(axios, basePath); });
        },
        donationCreditsControllerGetPreviewDonationCredit: function (donationCreditCreate, options) {
            return localVarFp
                .donationCreditsControllerGetPreviewDonationCredit(donationCreditCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DonationCreditsApiFactory = DonationCreditsApiFactory;
var DonationCreditsApi = (function (_super) {
    tslib_1.__extends(DonationCreditsApi, _super);
    function DonationCreditsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DonationCreditsApi.prototype.donationCreditsControllerCreateDonationCredit = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DonationCreditsApiFp)(this.configuration)
            .donationCreditsControllerCreateDonationCredit(requestParameters.givzDeviceId, requestParameters.donationCreditCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DonationCreditsApi.prototype.donationCreditsControllerGetDonationCreditFromToken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DonationCreditsApiFp)(this.configuration)
            .donationCreditsControllerGetDonationCreditFromToken(requestParameters.token, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DonationCreditsApi.prototype.donationCreditsControllerGetPreviewDonationCredit = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DonationCreditsApiFp)(this.configuration)
            .donationCreditsControllerGetPreviewDonationCredit(requestParameters.donationCreditCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DonationCreditsApi;
}(base_1.BaseAPI));
exports.DonationCreditsApi = DonationCreditsApi;
var DonationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        donationsControllerCreateDonation: function (givzDeviceId, donationCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('donationsControllerCreateDonation', 'givzDeviceId', givzDeviceId);
                    (0, common_1.assertParamExists)('donationsControllerCreateDonation', 'donationCreate', donationCreate);
                    localVarPath = "/core/v1/donations";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (givzDeviceId !== undefined && givzDeviceId !== null) {
                        localVarHeaderParameter['givz_device_id'] = String(givzDeviceId);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(donationCreate, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        donationsControllerExportDonations: function (page, pageSize, campaignGids, endedAt, startedAt, invoiceKey, organizationGid, type, emails, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/donations/export";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (campaignGids) {
                                localVarQueryParameter['campaignGids'] = campaignGids;
                            }
                            if (endedAt !== undefined) {
                                localVarQueryParameter['endedAt'] =
                                    endedAt instanceof Date
                                        ? endedAt.toISOString()
                                        : endedAt;
                            }
                            if (startedAt !== undefined) {
                                localVarQueryParameter['startedAt'] =
                                    startedAt instanceof Date
                                        ? startedAt.toISOString()
                                        : startedAt;
                            }
                            if (invoiceKey !== undefined) {
                                localVarQueryParameter['invoiceKey'] = invoiceKey;
                            }
                            if (organizationGid !== undefined) {
                                localVarQueryParameter['organizationGid'] = organizationGid;
                            }
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            if (emails) {
                                localVarQueryParameter['emails'] = emails;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        donationsControllerFindOne: function (id, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('donationsControllerFindOne', 'id', id);
                    localVarPath = "/core/v1/donations/{id}".replace("{".concat('id', "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        donationsControllerGetDonationFromGid: function (gid, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('donationsControllerGetDonationFromGid', 'gid', gid);
                            localVarPath = "/core/v1/donations/{gid}".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        donationsControllerSearchDonations: function (page, pageSize, campaignGids, endedAt, startedAt, invoiceKey, organizationGid, type, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/donations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (campaignGids) {
                                localVarQueryParameter['campaignGids'] = campaignGids;
                            }
                            if (endedAt !== undefined) {
                                localVarQueryParameter['endedAt'] =
                                    endedAt instanceof Date
                                        ? endedAt.toISOString()
                                        : endedAt;
                            }
                            if (startedAt !== undefined) {
                                localVarQueryParameter['startedAt'] =
                                    startedAt instanceof Date
                                        ? startedAt.toISOString()
                                        : startedAt;
                            }
                            if (invoiceKey !== undefined) {
                                localVarQueryParameter['invoiceKey'] = invoiceKey;
                            }
                            if (organizationGid !== undefined) {
                                localVarQueryParameter['organizationGid'] = organizationGid;
                            }
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        donationsControllerShareDonation: function (gid, instagramUsername, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('donationsControllerShareDonation', 'gid', gid);
                    (0, common_1.assertParamExists)('donationsControllerShareDonation', 'instagramUsername', instagramUsername);
                    localVarPath = "/core/v1/donations/{gid}/share".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (instagramUsername !== undefined) {
                        localVarQueryParameter['instagramUsername'] = instagramUsername;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        donationsControllerVoidDonation: function (gid, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('donationsControllerVoidDonation', 'gid', gid);
                            localVarPath = "/core/v1/donations/{gid}/void".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DonationsApiAxiosParamCreator = DonationsApiAxiosParamCreator;
var DonationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DonationsApiAxiosParamCreator)(configuration);
    return {
        donationsControllerCreateDonation: function (givzDeviceId, donationCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.donationsControllerCreateDonation(givzDeviceId, donationCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        donationsControllerExportDonations: function (page, pageSize, campaignGids, endedAt, startedAt, invoiceKey, organizationGid, type, emails, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.donationsControllerExportDonations(page, pageSize, campaignGids, endedAt, startedAt, invoiceKey, organizationGid, type, emails, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        donationsControllerFindOne: function (id, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.donationsControllerFindOne(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        donationsControllerGetDonationFromGid: function (gid, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.donationsControllerGetDonationFromGid(gid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        donationsControllerSearchDonations: function (page, pageSize, campaignGids, endedAt, startedAt, invoiceKey, organizationGid, type, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.donationsControllerSearchDonations(page, pageSize, campaignGids, endedAt, startedAt, invoiceKey, organizationGid, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        donationsControllerShareDonation: function (gid, instagramUsername, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.donationsControllerShareDonation(gid, instagramUsername, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        donationsControllerVoidDonation: function (gid, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.donationsControllerVoidDonation(gid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DonationsApiFp = DonationsApiFp;
var DonationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DonationsApiFp)(configuration);
    return {
        donationsControllerCreateDonation: function (givzDeviceId, donationCreate, options) {
            return localVarFp
                .donationsControllerCreateDonation(givzDeviceId, donationCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        donationsControllerExportDonations: function (page, pageSize, campaignGids, endedAt, startedAt, invoiceKey, organizationGid, type, emails, options) {
            return localVarFp
                .donationsControllerExportDonations(page, pageSize, campaignGids, endedAt, startedAt, invoiceKey, organizationGid, type, emails, options)
                .then(function (request) { return request(axios, basePath); });
        },
        donationsControllerFindOne: function (id, options) {
            return localVarFp
                .donationsControllerFindOne(id, options)
                .then(function (request) { return request(axios, basePath); });
        },
        donationsControllerGetDonationFromGid: function (gid, options) {
            return localVarFp
                .donationsControllerGetDonationFromGid(gid, options)
                .then(function (request) { return request(axios, basePath); });
        },
        donationsControllerSearchDonations: function (page, pageSize, campaignGids, endedAt, startedAt, invoiceKey, organizationGid, type, options) {
            return localVarFp
                .donationsControllerSearchDonations(page, pageSize, campaignGids, endedAt, startedAt, invoiceKey, organizationGid, type, options)
                .then(function (request) { return request(axios, basePath); });
        },
        donationsControllerShareDonation: function (gid, instagramUsername, options) {
            return localVarFp
                .donationsControllerShareDonation(gid, instagramUsername, options)
                .then(function (request) { return request(axios, basePath); });
        },
        donationsControllerVoidDonation: function (gid, options) {
            return localVarFp
                .donationsControllerVoidDonation(gid, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DonationsApiFactory = DonationsApiFactory;
var DonationsApi = (function (_super) {
    tslib_1.__extends(DonationsApi, _super);
    function DonationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DonationsApi.prototype.donationsControllerCreateDonation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DonationsApiFp)(this.configuration)
            .donationsControllerCreateDonation(requestParameters.givzDeviceId, requestParameters.donationCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DonationsApi.prototype.donationsControllerExportDonations = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DonationsApiFp)(this.configuration)
            .donationsControllerExportDonations(requestParameters.page, requestParameters.pageSize, requestParameters.campaignGids, requestParameters.endedAt, requestParameters.startedAt, requestParameters.invoiceKey, requestParameters.organizationGid, requestParameters.type, requestParameters.emails, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DonationsApi.prototype.donationsControllerFindOne = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DonationsApiFp)(this.configuration)
            .donationsControllerFindOne(requestParameters.id, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DonationsApi.prototype.donationsControllerGetDonationFromGid = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DonationsApiFp)(this.configuration)
            .donationsControllerGetDonationFromGid(requestParameters.gid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DonationsApi.prototype.donationsControllerSearchDonations = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DonationsApiFp)(this.configuration)
            .donationsControllerSearchDonations(requestParameters.page, requestParameters.pageSize, requestParameters.campaignGids, requestParameters.endedAt, requestParameters.startedAt, requestParameters.invoiceKey, requestParameters.organizationGid, requestParameters.type, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DonationsApi.prototype.donationsControllerShareDonation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DonationsApiFp)(this.configuration)
            .donationsControllerShareDonation(requestParameters.gid, requestParameters.instagramUsername, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DonationsApi.prototype.donationsControllerVoidDonation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DonationsApiFp)(this.configuration)
            .donationsControllerVoidDonation(requestParameters.gid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DonationsApi;
}(base_1.BaseAPI));
exports.DonationsApi = DonationsApi;
var FeaturesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        featuresControllerGetAllFeatures: function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/features";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FeaturesApiAxiosParamCreator = FeaturesApiAxiosParamCreator;
var FeaturesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FeaturesApiAxiosParamCreator)(configuration);
    return {
        featuresControllerGetAllFeatures: function (options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.featuresControllerGetAllFeatures(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FeaturesApiFp = FeaturesApiFp;
var FeaturesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FeaturesApiFp)(configuration);
    return {
        featuresControllerGetAllFeatures: function (options) {
            return localVarFp
                .featuresControllerGetAllFeatures(options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FeaturesApiFactory = FeaturesApiFactory;
var FeaturesApi = (function (_super) {
    tslib_1.__extends(FeaturesApi, _super);
    function FeaturesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeaturesApi.prototype.featuresControllerGetAllFeatures = function (options) {
        var _this = this;
        return (0, exports.FeaturesApiFp)(this.configuration)
            .featuresControllerGetAllFeatures(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FeaturesApi;
}(base_1.BaseAPI));
exports.FeaturesApi = FeaturesApi;
var FileUploadsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        fileUploadsControllerGetUploadRequestSignature: function (fileUploadSignatureRequestCreateDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('fileUploadsControllerGetUploadRequestSignature', 'fileUploadSignatureRequestCreateDto', fileUploadSignatureRequestCreateDto);
                            localVarPath = "/core/v1/fileUploads/uploadRequestSignature";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fileUploadSignatureRequestCreateDto, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FileUploadsApiAxiosParamCreator = FileUploadsApiAxiosParamCreator;
var FileUploadsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FileUploadsApiAxiosParamCreator)(configuration);
    return {
        fileUploadsControllerGetUploadRequestSignature: function (fileUploadSignatureRequestCreateDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.fileUploadsControllerGetUploadRequestSignature(fileUploadSignatureRequestCreateDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FileUploadsApiFp = FileUploadsApiFp;
var FileUploadsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FileUploadsApiFp)(configuration);
    return {
        fileUploadsControllerGetUploadRequestSignature: function (fileUploadSignatureRequestCreateDto, options) {
            return localVarFp
                .fileUploadsControllerGetUploadRequestSignature(fileUploadSignatureRequestCreateDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FileUploadsApiFactory = FileUploadsApiFactory;
var FileUploadsApi = (function (_super) {
    tslib_1.__extends(FileUploadsApi, _super);
    function FileUploadsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FileUploadsApi.prototype.fileUploadsControllerGetUploadRequestSignature = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FileUploadsApiFp)(this.configuration)
            .fileUploadsControllerGetUploadRequestSignature(requestParameters.fileUploadSignatureRequestCreateDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FileUploadsApi;
}(base_1.BaseAPI));
exports.FileUploadsApi = FileUploadsApi;
var FreeTrialsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        freeTrialsControllerGetFreeTrial: function (body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('freeTrialsControllerGetFreeTrial', 'body', body);
                            localVarPath = "/core/v1/freeTrials";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FreeTrialsApiAxiosParamCreator = FreeTrialsApiAxiosParamCreator;
var FreeTrialsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FreeTrialsApiAxiosParamCreator)(configuration);
    return {
        freeTrialsControllerGetFreeTrial: function (body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.freeTrialsControllerGetFreeTrial(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FreeTrialsApiFp = FreeTrialsApiFp;
var FreeTrialsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FreeTrialsApiFp)(configuration);
    return {
        freeTrialsControllerGetFreeTrial: function (body, options) {
            return localVarFp
                .freeTrialsControllerGetFreeTrial(body, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FreeTrialsApiFactory = FreeTrialsApiFactory;
var FreeTrialsApi = (function (_super) {
    tslib_1.__extends(FreeTrialsApi, _super);
    function FreeTrialsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeTrialsApi.prototype.freeTrialsControllerGetFreeTrial = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreeTrialsApiFp)(this.configuration)
            .freeTrialsControllerGetFreeTrial(requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FreeTrialsApi;
}(base_1.BaseAPI));
exports.FreeTrialsApi = FreeTrialsApi;
var HostedApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        hostedCampaignsControllerActivateCampaign: function (gid, body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('hostedCampaignsControllerActivateCampaign', 'gid', gid);
                            (0, common_1.assertParamExists)('hostedCampaignsControllerActivateCampaign', 'body', body);
                            localVarPath = "/core/v1/hosted/campaigns/{gid}/activate".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        hostedCampaignsControllerCampaignGenerator: function (hostedCampaignGeneratorCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('hostedCampaignsControllerCampaignGenerator', 'hostedCampaignGeneratorCreate', hostedCampaignGeneratorCreate);
                            localVarPath = "/core/v1/hosted/campaigns/generator";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hostedCampaignGeneratorCreate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        hostedCampaignsControllerDeactivateCampaign: function (gid, body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('hostedCampaignsControllerDeactivateCampaign', 'gid', gid);
                            (0, common_1.assertParamExists)('hostedCampaignsControllerDeactivateCampaign', 'body', body);
                            localVarPath = "/core/v1/hosted/campaigns/{gid}/deactivate".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        hostedCampaignsControllerDuplicateCampaign: function (gid, hostedCampaignDuplicateDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('hostedCampaignsControllerDuplicateCampaign', 'gid', gid);
                            (0, common_1.assertParamExists)('hostedCampaignsControllerDuplicateCampaign', 'hostedCampaignDuplicateDto', hostedCampaignDuplicateDto);
                            localVarPath = "/core/v1/hosted/campaigns/{gid}/duplicate".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hostedCampaignDuplicateDto, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        hostedCampaignsControllerGetCampaign: function (gid, body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('hostedCampaignsControllerGetCampaign', 'gid', gid);
                            (0, common_1.assertParamExists)('hostedCampaignsControllerGetCampaign', 'body', body);
                            localVarPath = "/core/v1/hosted/campaigns/{gid}".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        hostedCampaignsControllerGetCampaigns: function (body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('hostedCampaignsControllerGetCampaigns', 'body', body);
                            localVarPath = "/core/v1/hosted/campaigns";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        hostedCampaignsControllerOverview: function (campaignGids, endedAt, startedAt, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/hosted/campaigns/overview";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (campaignGids) {
                                localVarQueryParameter['campaignGids'] = campaignGids;
                            }
                            if (endedAt !== undefined) {
                                localVarQueryParameter['endedAt'] =
                                    endedAt instanceof Date
                                        ? endedAt.toISOString()
                                        : endedAt;
                            }
                            if (startedAt !== undefined) {
                                localVarQueryParameter['startedAt'] =
                                    startedAt instanceof Date
                                        ? startedAt.toISOString()
                                        : startedAt;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        hostedCampaignsControllerUpdateCampaign: function (gid, hostedCampaignGeneratorUpdate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('hostedCampaignsControllerUpdateCampaign', 'gid', gid);
                            (0, common_1.assertParamExists)('hostedCampaignsControllerUpdateCampaign', 'hostedCampaignGeneratorUpdate', hostedCampaignGeneratorUpdate);
                            localVarPath = "/core/v1/hosted/campaigns/{gid}".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hostedCampaignGeneratorUpdate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.HostedApiAxiosParamCreator = HostedApiAxiosParamCreator;
var HostedApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HostedApiAxiosParamCreator)(configuration);
    return {
        hostedCampaignsControllerActivateCampaign: function (gid, body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.hostedCampaignsControllerActivateCampaign(gid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        hostedCampaignsControllerCampaignGenerator: function (hostedCampaignGeneratorCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.hostedCampaignsControllerCampaignGenerator(hostedCampaignGeneratorCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        hostedCampaignsControllerDeactivateCampaign: function (gid, body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.hostedCampaignsControllerDeactivateCampaign(gid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        hostedCampaignsControllerDuplicateCampaign: function (gid, hostedCampaignDuplicateDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.hostedCampaignsControllerDuplicateCampaign(gid, hostedCampaignDuplicateDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        hostedCampaignsControllerGetCampaign: function (gid, body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.hostedCampaignsControllerGetCampaign(gid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        hostedCampaignsControllerGetCampaigns: function (body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.hostedCampaignsControllerGetCampaigns(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        hostedCampaignsControllerOverview: function (campaignGids, endedAt, startedAt, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.hostedCampaignsControllerOverview(campaignGids, endedAt, startedAt, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        hostedCampaignsControllerUpdateCampaign: function (gid, hostedCampaignGeneratorUpdate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.hostedCampaignsControllerUpdateCampaign(gid, hostedCampaignGeneratorUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.HostedApiFp = HostedApiFp;
var HostedApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HostedApiFp)(configuration);
    return {
        hostedCampaignsControllerActivateCampaign: function (gid, body, options) {
            return localVarFp
                .hostedCampaignsControllerActivateCampaign(gid, body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        hostedCampaignsControllerCampaignGenerator: function (hostedCampaignGeneratorCreate, options) {
            return localVarFp
                .hostedCampaignsControllerCampaignGenerator(hostedCampaignGeneratorCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        hostedCampaignsControllerDeactivateCampaign: function (gid, body, options) {
            return localVarFp
                .hostedCampaignsControllerDeactivateCampaign(gid, body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        hostedCampaignsControllerDuplicateCampaign: function (gid, hostedCampaignDuplicateDto, options) {
            return localVarFp
                .hostedCampaignsControllerDuplicateCampaign(gid, hostedCampaignDuplicateDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        hostedCampaignsControllerGetCampaign: function (gid, body, options) {
            return localVarFp
                .hostedCampaignsControllerGetCampaign(gid, body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        hostedCampaignsControllerGetCampaigns: function (body, options) {
            return localVarFp
                .hostedCampaignsControllerGetCampaigns(body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        hostedCampaignsControllerOverview: function (campaignGids, endedAt, startedAt, options) {
            return localVarFp
                .hostedCampaignsControllerOverview(campaignGids, endedAt, startedAt, options)
                .then(function (request) { return request(axios, basePath); });
        },
        hostedCampaignsControllerUpdateCampaign: function (gid, hostedCampaignGeneratorUpdate, options) {
            return localVarFp
                .hostedCampaignsControllerUpdateCampaign(gid, hostedCampaignGeneratorUpdate, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HostedApiFactory = HostedApiFactory;
var HostedApi = (function (_super) {
    tslib_1.__extends(HostedApi, _super);
    function HostedApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HostedApi.prototype.hostedCampaignsControllerActivateCampaign = function (requestParameters, options) {
        var _this = this;
        return (0, exports.HostedApiFp)(this.configuration)
            .hostedCampaignsControllerActivateCampaign(requestParameters.gid, requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    HostedApi.prototype.hostedCampaignsControllerCampaignGenerator = function (requestParameters, options) {
        var _this = this;
        return (0, exports.HostedApiFp)(this.configuration)
            .hostedCampaignsControllerCampaignGenerator(requestParameters.hostedCampaignGeneratorCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    HostedApi.prototype.hostedCampaignsControllerDeactivateCampaign = function (requestParameters, options) {
        var _this = this;
        return (0, exports.HostedApiFp)(this.configuration)
            .hostedCampaignsControllerDeactivateCampaign(requestParameters.gid, requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    HostedApi.prototype.hostedCampaignsControllerDuplicateCampaign = function (requestParameters, options) {
        var _this = this;
        return (0, exports.HostedApiFp)(this.configuration)
            .hostedCampaignsControllerDuplicateCampaign(requestParameters.gid, requestParameters.hostedCampaignDuplicateDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    HostedApi.prototype.hostedCampaignsControllerGetCampaign = function (requestParameters, options) {
        var _this = this;
        return (0, exports.HostedApiFp)(this.configuration)
            .hostedCampaignsControllerGetCampaign(requestParameters.gid, requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    HostedApi.prototype.hostedCampaignsControllerGetCampaigns = function (requestParameters, options) {
        var _this = this;
        return (0, exports.HostedApiFp)(this.configuration)
            .hostedCampaignsControllerGetCampaigns(requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    HostedApi.prototype.hostedCampaignsControllerOverview = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.HostedApiFp)(this.configuration)
            .hostedCampaignsControllerOverview(requestParameters.campaignGids, requestParameters.endedAt, requestParameters.startedAt, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    HostedApi.prototype.hostedCampaignsControllerUpdateCampaign = function (requestParameters, options) {
        var _this = this;
        return (0, exports.HostedApiFp)(this.configuration)
            .hostedCampaignsControllerUpdateCampaign(requestParameters.gid, requestParameters.hostedCampaignGeneratorUpdate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HostedApi;
}(base_1.BaseAPI));
exports.HostedApi = HostedApi;
var ImpersonatorApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        impersonatorControllerGetAccounts: function (q, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/impersonator/accounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        impersonatorControllerImpersonate: function (impersonatorImpersonateDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('impersonatorControllerImpersonate', 'impersonatorImpersonateDto', impersonatorImpersonateDto);
                            localVarPath = "/core/v1/impersonator/impersonate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(impersonatorImpersonateDto, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ImpersonatorApiAxiosParamCreator = ImpersonatorApiAxiosParamCreator;
var ImpersonatorApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ImpersonatorApiAxiosParamCreator)(configuration);
    return {
        impersonatorControllerGetAccounts: function (q, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.impersonatorControllerGetAccounts(q, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        impersonatorControllerImpersonate: function (impersonatorImpersonateDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.impersonatorControllerImpersonate(impersonatorImpersonateDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ImpersonatorApiFp = ImpersonatorApiFp;
var ImpersonatorApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ImpersonatorApiFp)(configuration);
    return {
        impersonatorControllerGetAccounts: function (q, options) {
            return localVarFp
                .impersonatorControllerGetAccounts(q, options)
                .then(function (request) { return request(axios, basePath); });
        },
        impersonatorControllerImpersonate: function (impersonatorImpersonateDto, options) {
            return localVarFp
                .impersonatorControllerImpersonate(impersonatorImpersonateDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ImpersonatorApiFactory = ImpersonatorApiFactory;
var ImpersonatorApi = (function (_super) {
    tslib_1.__extends(ImpersonatorApi, _super);
    function ImpersonatorApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImpersonatorApi.prototype.impersonatorControllerGetAccounts = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ImpersonatorApiFp)(this.configuration)
            .impersonatorControllerGetAccounts(requestParameters.q, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    ImpersonatorApi.prototype.impersonatorControllerImpersonate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ImpersonatorApiFp)(this.configuration)
            .impersonatorControllerImpersonate(requestParameters.impersonatorImpersonateDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ImpersonatorApi;
}(base_1.BaseAPI));
exports.ImpersonatorApi = ImpersonatorApi;
var IntegrationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        integrationsControllerCreateAttentiveIntegration: function (attentiveCreateDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('integrationsControllerCreateAttentiveIntegration', 'attentiveCreateDto', attentiveCreateDto);
                            localVarPath = "/core/v1/integrations/attentive";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(attentiveCreateDto, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        integrationsControllerCreateKlaviyoIntegration: function (integrationBaseCreateDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('integrationsControllerCreateKlaviyoIntegration', 'integrationBaseCreateDto', integrationBaseCreateDto);
                            localVarPath = "/core/v1/integrations/klaviyo";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(integrationBaseCreateDto, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        integrationsControllerCreatePostscriptIntegration: function (integrationBaseCreateDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('integrationsControllerCreatePostscriptIntegration', 'integrationBaseCreateDto', integrationBaseCreateDto);
                            localVarPath = "/core/v1/integrations/postscript";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(integrationBaseCreateDto, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        integrationsControllerDeleteAttentiveIntegration: function (body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('integrationsControllerDeleteAttentiveIntegration', 'body', body);
                            localVarPath = "/core/v1/integrations/attentive";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        integrationsControllerDeleteKlaviyoIntegration: function (body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('integrationsControllerDeleteKlaviyoIntegration', 'body', body);
                            localVarPath = "/core/v1/integrations/klaviyo";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        integrationsControllerDeletePostscriptIntegration: function (body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('integrationsControllerDeletePostscriptIntegration', 'body', body);
                            localVarPath = "/core/v1/integrations/postscript";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        integrationsControllerGetIntegrations: function (body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('integrationsControllerGetIntegrations', 'body', body);
                            localVarPath = "/core/v1/integrations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        integrationsControllerSyncAttentiveSubscriberAttributes: function (body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('integrationsControllerSyncAttentiveSubscriberAttributes', 'body', body);
                            localVarPath = "/core/v1/integrations/attentive/syncSubscribers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        integrationsControllerSyncKlaviyoEvents: function (body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('integrationsControllerSyncKlaviyoEvents', 'body', body);
                            localVarPath = "/core/v1/integrations/klaviyo/syncEvents";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        integrationsControllerSyncPostscriptSubscriberAttributes: function (body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('integrationsControllerSyncPostscriptSubscriberAttributes', 'body', body);
                            localVarPath = "/core/v1/integrations/postscript/syncSubscribers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        integrationsControllerSyncShopifyMetadata: function (body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('integrationsControllerSyncShopifyMetadata', 'body', body);
                            localVarPath = "/core/v1/integrations/shopify/syncMetadata";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        integrationsControllerUpdateIntegrations: function (integrationsUpdateDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('integrationsControllerUpdateIntegrations', 'integrationsUpdateDto', integrationsUpdateDto);
                            localVarPath = "/core/v1/integrations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(integrationsUpdateDto, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.IntegrationsApiAxiosParamCreator = IntegrationsApiAxiosParamCreator;
var IntegrationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.IntegrationsApiAxiosParamCreator)(configuration);
    return {
        integrationsControllerCreateAttentiveIntegration: function (attentiveCreateDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.integrationsControllerCreateAttentiveIntegration(attentiveCreateDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        integrationsControllerCreateKlaviyoIntegration: function (integrationBaseCreateDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.integrationsControllerCreateKlaviyoIntegration(integrationBaseCreateDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        integrationsControllerCreatePostscriptIntegration: function (integrationBaseCreateDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.integrationsControllerCreatePostscriptIntegration(integrationBaseCreateDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        integrationsControllerDeleteAttentiveIntegration: function (body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.integrationsControllerDeleteAttentiveIntegration(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        integrationsControllerDeleteKlaviyoIntegration: function (body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.integrationsControllerDeleteKlaviyoIntegration(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        integrationsControllerDeletePostscriptIntegration: function (body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.integrationsControllerDeletePostscriptIntegration(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        integrationsControllerGetIntegrations: function (body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.integrationsControllerGetIntegrations(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        integrationsControllerSyncAttentiveSubscriberAttributes: function (body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.integrationsControllerSyncAttentiveSubscriberAttributes(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        integrationsControllerSyncKlaviyoEvents: function (body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.integrationsControllerSyncKlaviyoEvents(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        integrationsControllerSyncPostscriptSubscriberAttributes: function (body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.integrationsControllerSyncPostscriptSubscriberAttributes(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        integrationsControllerSyncShopifyMetadata: function (body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.integrationsControllerSyncShopifyMetadata(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        integrationsControllerUpdateIntegrations: function (integrationsUpdateDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.integrationsControllerUpdateIntegrations(integrationsUpdateDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.IntegrationsApiFp = IntegrationsApiFp;
var IntegrationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.IntegrationsApiFp)(configuration);
    return {
        integrationsControllerCreateAttentiveIntegration: function (attentiveCreateDto, options) {
            return localVarFp
                .integrationsControllerCreateAttentiveIntegration(attentiveCreateDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        integrationsControllerCreateKlaviyoIntegration: function (integrationBaseCreateDto, options) {
            return localVarFp
                .integrationsControllerCreateKlaviyoIntegration(integrationBaseCreateDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        integrationsControllerCreatePostscriptIntegration: function (integrationBaseCreateDto, options) {
            return localVarFp
                .integrationsControllerCreatePostscriptIntegration(integrationBaseCreateDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        integrationsControllerDeleteAttentiveIntegration: function (body, options) {
            return localVarFp
                .integrationsControllerDeleteAttentiveIntegration(body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        integrationsControllerDeleteKlaviyoIntegration: function (body, options) {
            return localVarFp
                .integrationsControllerDeleteKlaviyoIntegration(body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        integrationsControllerDeletePostscriptIntegration: function (body, options) {
            return localVarFp
                .integrationsControllerDeletePostscriptIntegration(body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        integrationsControllerGetIntegrations: function (body, options) {
            return localVarFp
                .integrationsControllerGetIntegrations(body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        integrationsControllerSyncAttentiveSubscriberAttributes: function (body, options) {
            return localVarFp
                .integrationsControllerSyncAttentiveSubscriberAttributes(body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        integrationsControllerSyncKlaviyoEvents: function (body, options) {
            return localVarFp
                .integrationsControllerSyncKlaviyoEvents(body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        integrationsControllerSyncPostscriptSubscriberAttributes: function (body, options) {
            return localVarFp
                .integrationsControllerSyncPostscriptSubscriberAttributes(body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        integrationsControllerSyncShopifyMetadata: function (body, options) {
            return localVarFp
                .integrationsControllerSyncShopifyMetadata(body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        integrationsControllerUpdateIntegrations: function (integrationsUpdateDto, options) {
            return localVarFp
                .integrationsControllerUpdateIntegrations(integrationsUpdateDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.IntegrationsApiFactory = IntegrationsApiFactory;
var IntegrationsApi = (function (_super) {
    tslib_1.__extends(IntegrationsApi, _super);
    function IntegrationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IntegrationsApi.prototype.integrationsControllerCreateAttentiveIntegration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration)
            .integrationsControllerCreateAttentiveIntegration(requestParameters.attentiveCreateDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    IntegrationsApi.prototype.integrationsControllerCreateKlaviyoIntegration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration)
            .integrationsControllerCreateKlaviyoIntegration(requestParameters.integrationBaseCreateDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    IntegrationsApi.prototype.integrationsControllerCreatePostscriptIntegration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration)
            .integrationsControllerCreatePostscriptIntegration(requestParameters.integrationBaseCreateDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    IntegrationsApi.prototype.integrationsControllerDeleteAttentiveIntegration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration)
            .integrationsControllerDeleteAttentiveIntegration(requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    IntegrationsApi.prototype.integrationsControllerDeleteKlaviyoIntegration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration)
            .integrationsControllerDeleteKlaviyoIntegration(requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    IntegrationsApi.prototype.integrationsControllerDeletePostscriptIntegration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration)
            .integrationsControllerDeletePostscriptIntegration(requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    IntegrationsApi.prototype.integrationsControllerGetIntegrations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration)
            .integrationsControllerGetIntegrations(requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    IntegrationsApi.prototype.integrationsControllerSyncAttentiveSubscriberAttributes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration)
            .integrationsControllerSyncAttentiveSubscriberAttributes(requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    IntegrationsApi.prototype.integrationsControllerSyncKlaviyoEvents = function (requestParameters, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration)
            .integrationsControllerSyncKlaviyoEvents(requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    IntegrationsApi.prototype.integrationsControllerSyncPostscriptSubscriberAttributes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration)
            .integrationsControllerSyncPostscriptSubscriberAttributes(requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    IntegrationsApi.prototype.integrationsControllerSyncShopifyMetadata = function (requestParameters, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration)
            .integrationsControllerSyncShopifyMetadata(requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    IntegrationsApi.prototype.integrationsControllerUpdateIntegrations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration)
            .integrationsControllerUpdateIntegrations(requestParameters.integrationsUpdateDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return IntegrationsApi;
}(base_1.BaseAPI));
exports.IntegrationsApi = IntegrationsApi;
var InvoicesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        invoicesControllerFindOne: function (id, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('invoicesControllerFindOne', 'id', id);
                            localVarPath = "/core/v1/invoices/{id}".replace("{".concat('id', "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        invoicesControllerSearchInvoices: function (page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/invoices";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.InvoicesApiAxiosParamCreator = InvoicesApiAxiosParamCreator;
var InvoicesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.InvoicesApiAxiosParamCreator)(configuration);
    return {
        invoicesControllerFindOne: function (id, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.invoicesControllerFindOne(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        invoicesControllerSearchInvoices: function (page, pageSize, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.invoicesControllerSearchInvoices(page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.InvoicesApiFp = InvoicesApiFp;
var InvoicesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.InvoicesApiFp)(configuration);
    return {
        invoicesControllerFindOne: function (id, options) {
            return localVarFp
                .invoicesControllerFindOne(id, options)
                .then(function (request) { return request(axios, basePath); });
        },
        invoicesControllerSearchInvoices: function (page, pageSize, options) {
            return localVarFp
                .invoicesControllerSearchInvoices(page, pageSize, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.InvoicesApiFactory = InvoicesApiFactory;
var InvoicesApi = (function (_super) {
    tslib_1.__extends(InvoicesApi, _super);
    function InvoicesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InvoicesApi.prototype.invoicesControllerFindOne = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InvoicesApiFp)(this.configuration)
            .invoicesControllerFindOne(requestParameters.id, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    InvoicesApi.prototype.invoicesControllerSearchInvoices = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.InvoicesApiFp)(this.configuration)
            .invoicesControllerSearchInvoices(requestParameters.page, requestParameters.pageSize, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return InvoicesApi;
}(base_1.BaseAPI));
exports.InvoicesApi = InvoicesApi;
var OrdersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        ordersControllerExportOrders: function (page, pageSize, campaignGids, endedAt, startedAt, qualifying, emails, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/orders/export";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (campaignGids) {
                                localVarQueryParameter['campaignGids'] = campaignGids;
                            }
                            if (endedAt !== undefined) {
                                localVarQueryParameter['endedAt'] =
                                    endedAt instanceof Date
                                        ? endedAt.toISOString()
                                        : endedAt;
                            }
                            if (startedAt !== undefined) {
                                localVarQueryParameter['startedAt'] =
                                    startedAt instanceof Date
                                        ? startedAt.toISOString()
                                        : startedAt;
                            }
                            if (qualifying !== undefined) {
                                localVarQueryParameter['qualifying'] = qualifying;
                            }
                            if (emails) {
                                localVarQueryParameter['emails'] = emails;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        ordersControllerFindOne: function (id, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('ordersControllerFindOne', 'id', id);
                            localVarPath = "/core/v1/orders/{id}".replace("{".concat('id', "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        ordersControllerSearchOrders: function (page, pageSize, campaignGids, endedAt, startedAt, qualifying, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/orders";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (campaignGids) {
                                localVarQueryParameter['campaignGids'] = campaignGids;
                            }
                            if (endedAt !== undefined) {
                                localVarQueryParameter['endedAt'] =
                                    endedAt instanceof Date
                                        ? endedAt.toISOString()
                                        : endedAt;
                            }
                            if (startedAt !== undefined) {
                                localVarQueryParameter['startedAt'] =
                                    startedAt instanceof Date
                                        ? startedAt.toISOString()
                                        : startedAt;
                            }
                            if (qualifying !== undefined) {
                                localVarQueryParameter['qualifying'] = qualifying;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OrdersApiAxiosParamCreator = OrdersApiAxiosParamCreator;
var OrdersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OrdersApiAxiosParamCreator)(configuration);
    return {
        ordersControllerExportOrders: function (page, pageSize, campaignGids, endedAt, startedAt, qualifying, emails, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.ordersControllerExportOrders(page, pageSize, campaignGids, endedAt, startedAt, qualifying, emails, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        ordersControllerFindOne: function (id, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.ordersControllerFindOne(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        ordersControllerSearchOrders: function (page, pageSize, campaignGids, endedAt, startedAt, qualifying, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.ordersControllerSearchOrders(page, pageSize, campaignGids, endedAt, startedAt, qualifying, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.OrdersApiFp = OrdersApiFp;
var OrdersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OrdersApiFp)(configuration);
    return {
        ordersControllerExportOrders: function (page, pageSize, campaignGids, endedAt, startedAt, qualifying, emails, options) {
            return localVarFp
                .ordersControllerExportOrders(page, pageSize, campaignGids, endedAt, startedAt, qualifying, emails, options)
                .then(function (request) { return request(axios, basePath); });
        },
        ordersControllerFindOne: function (id, options) {
            return localVarFp
                .ordersControllerFindOne(id, options)
                .then(function (request) { return request(axios, basePath); });
        },
        ordersControllerSearchOrders: function (page, pageSize, campaignGids, endedAt, startedAt, qualifying, options) {
            return localVarFp
                .ordersControllerSearchOrders(page, pageSize, campaignGids, endedAt, startedAt, qualifying, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OrdersApiFactory = OrdersApiFactory;
var OrdersApi = (function (_super) {
    tslib_1.__extends(OrdersApi, _super);
    function OrdersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrdersApi.prototype.ordersControllerExportOrders = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.OrdersApiFp)(this.configuration)
            .ordersControllerExportOrders(requestParameters.page, requestParameters.pageSize, requestParameters.campaignGids, requestParameters.endedAt, requestParameters.startedAt, requestParameters.qualifying, requestParameters.emails, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    OrdersApi.prototype.ordersControllerFindOne = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OrdersApiFp)(this.configuration)
            .ordersControllerFindOne(requestParameters.id, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    OrdersApi.prototype.ordersControllerSearchOrders = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.OrdersApiFp)(this.configuration)
            .ordersControllerSearchOrders(requestParameters.page, requestParameters.pageSize, requestParameters.campaignGids, requestParameters.endedAt, requestParameters.startedAt, requestParameters.qualifying, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrdersApi;
}(base_1.BaseAPI));
exports.OrdersApi = OrdersApi;
var OrganizationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        organizationsControllerFindOne: function (id, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('organizationsControllerFindOne', 'id', id);
                    localVarPath = "/core/v1/organizations/{id}".replace("{".concat('id', "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        organizationsControllerGetOrganization: function (gid, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('organizationsControllerGetOrganization', 'gid', gid);
                    localVarPath = "/core/v1/organizations/{gid}".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        organizationsControllerSearchOrganizations: function (page, pageSize, categoryId, ein, gid, name, q, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    localVarPath = "/core/v1/organizations";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (categoryId) {
                        localVarQueryParameter['categoryId'] = categoryId;
                    }
                    if (ein) {
                        localVarQueryParameter['ein'] = ein;
                    }
                    if (gid) {
                        localVarQueryParameter['gid'] = gid;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (q !== undefined) {
                        localVarQueryParameter['q'] = q;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.OrganizationsApiAxiosParamCreator = OrganizationsApiAxiosParamCreator;
var OrganizationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OrganizationsApiAxiosParamCreator)(configuration);
    return {
        organizationsControllerFindOne: function (id, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.organizationsControllerFindOne(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        organizationsControllerGetOrganization: function (gid, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.organizationsControllerGetOrganization(gid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        organizationsControllerSearchOrganizations: function (page, pageSize, categoryId, ein, gid, name, q, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.organizationsControllerSearchOrganizations(page, pageSize, categoryId, ein, gid, name, q, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.OrganizationsApiFp = OrganizationsApiFp;
var OrganizationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OrganizationsApiFp)(configuration);
    return {
        organizationsControllerFindOne: function (id, options) {
            return localVarFp
                .organizationsControllerFindOne(id, options)
                .then(function (request) { return request(axios, basePath); });
        },
        organizationsControllerGetOrganization: function (gid, options) {
            return localVarFp
                .organizationsControllerGetOrganization(gid, options)
                .then(function (request) { return request(axios, basePath); });
        },
        organizationsControllerSearchOrganizations: function (page, pageSize, categoryId, ein, gid, name, q, options) {
            return localVarFp
                .organizationsControllerSearchOrganizations(page, pageSize, categoryId, ein, gid, name, q, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OrganizationsApiFactory = OrganizationsApiFactory;
var OrganizationsApi = (function (_super) {
    tslib_1.__extends(OrganizationsApi, _super);
    function OrganizationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganizationsApi.prototype.organizationsControllerFindOne = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OrganizationsApiFp)(this.configuration)
            .organizationsControllerFindOne(requestParameters.id, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    OrganizationsApi.prototype.organizationsControllerGetOrganization = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OrganizationsApiFp)(this.configuration)
            .organizationsControllerGetOrganization(requestParameters.gid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    OrganizationsApi.prototype.organizationsControllerSearchOrganizations = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.OrganizationsApiFp)(this.configuration)
            .organizationsControllerSearchOrganizations(requestParameters.page, requestParameters.pageSize, requestParameters.categoryId, requestParameters.ein, requestParameters.gid, requestParameters.name, requestParameters.q, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrganizationsApi;
}(base_1.BaseAPI));
exports.OrganizationsApi = OrganizationsApi;
var PartnerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        partnerControllerCreateDonationCredit: function (partnerDonationCreditCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('partnerControllerCreateDonationCredit', 'partnerDonationCreditCreate', partnerDonationCreditCreate);
                            localVarPath = "/core/v1/partner/donationCredits";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(partnerDonationCreditCreate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        partnerControllerGetAllDonationCredits: function (page, pageSize, campaignId, referenceId, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/partner/donationCredits";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (campaignId !== undefined) {
                                localVarQueryParameter['campaignId'] = campaignId;
                            }
                            if (referenceId !== undefined) {
                                localVarQueryParameter['referenceId'] = referenceId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        partnerControllerGetAllDonations: function (page, pageSize, donationCreditCampaignId, donationCreditReferenceId, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/partner/donations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (donationCreditCampaignId !== undefined) {
                                localVarQueryParameter['donationCredit.campaignId'] =
                                    donationCreditCampaignId;
                            }
                            if (donationCreditReferenceId !== undefined) {
                                localVarQueryParameter['donationCredit.referenceId'] =
                                    donationCreditReferenceId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        partnerControllerGetDonation: function (gid, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('partnerControllerGetDonation', 'gid', gid);
                            localVarPath = "/core/v1/partner/donations/{gid}".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        partnerControllerGetDonationCredit: function (gid, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('partnerControllerGetDonationCredit', 'gid', gid);
                            localVarPath = "/core/v1/partner/donationCredits/{gid}".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        partnerControllerVoidDonation: function (gid, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('partnerControllerVoidDonation', 'gid', gid);
                            localVarPath = "/core/v1/partner/donations/{gid}/void".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PartnerApiAxiosParamCreator = PartnerApiAxiosParamCreator;
var PartnerApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PartnerApiAxiosParamCreator)(configuration);
    return {
        partnerControllerCreateDonationCredit: function (partnerDonationCreditCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.partnerControllerCreateDonationCredit(partnerDonationCreditCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        partnerControllerGetAllDonationCredits: function (page, pageSize, campaignId, referenceId, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.partnerControllerGetAllDonationCredits(page, pageSize, campaignId, referenceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        partnerControllerGetAllDonations: function (page, pageSize, donationCreditCampaignId, donationCreditReferenceId, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.partnerControllerGetAllDonations(page, pageSize, donationCreditCampaignId, donationCreditReferenceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        partnerControllerGetDonation: function (gid, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.partnerControllerGetDonation(gid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        partnerControllerGetDonationCredit: function (gid, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.partnerControllerGetDonationCredit(gid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        partnerControllerVoidDonation: function (gid, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.partnerControllerVoidDonation(gid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PartnerApiFp = PartnerApiFp;
var PartnerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PartnerApiFp)(configuration);
    return {
        partnerControllerCreateDonationCredit: function (partnerDonationCreditCreate, options) {
            return localVarFp
                .partnerControllerCreateDonationCredit(partnerDonationCreditCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        partnerControllerGetAllDonationCredits: function (page, pageSize, campaignId, referenceId, options) {
            return localVarFp
                .partnerControllerGetAllDonationCredits(page, pageSize, campaignId, referenceId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        partnerControllerGetAllDonations: function (page, pageSize, donationCreditCampaignId, donationCreditReferenceId, options) {
            return localVarFp
                .partnerControllerGetAllDonations(page, pageSize, donationCreditCampaignId, donationCreditReferenceId, options)
                .then(function (request) { return request(axios, basePath); });
        },
        partnerControllerGetDonation: function (gid, options) {
            return localVarFp
                .partnerControllerGetDonation(gid, options)
                .then(function (request) { return request(axios, basePath); });
        },
        partnerControllerGetDonationCredit: function (gid, options) {
            return localVarFp
                .partnerControllerGetDonationCredit(gid, options)
                .then(function (request) { return request(axios, basePath); });
        },
        partnerControllerVoidDonation: function (gid, options) {
            return localVarFp
                .partnerControllerVoidDonation(gid, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PartnerApiFactory = PartnerApiFactory;
var PartnerApi = (function (_super) {
    tslib_1.__extends(PartnerApi, _super);
    function PartnerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PartnerApi.prototype.partnerControllerCreateDonationCredit = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PartnerApiFp)(this.configuration)
            .partnerControllerCreateDonationCredit(requestParameters.partnerDonationCreditCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    PartnerApi.prototype.partnerControllerGetAllDonationCredits = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PartnerApiFp)(this.configuration)
            .partnerControllerGetAllDonationCredits(requestParameters.page, requestParameters.pageSize, requestParameters.campaignId, requestParameters.referenceId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    PartnerApi.prototype.partnerControllerGetAllDonations = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PartnerApiFp)(this.configuration)
            .partnerControllerGetAllDonations(requestParameters.page, requestParameters.pageSize, requestParameters.donationCreditCampaignId, requestParameters.donationCreditReferenceId, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    PartnerApi.prototype.partnerControllerGetDonation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PartnerApiFp)(this.configuration)
            .partnerControllerGetDonation(requestParameters.gid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    PartnerApi.prototype.partnerControllerGetDonationCredit = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PartnerApiFp)(this.configuration)
            .partnerControllerGetDonationCredit(requestParameters.gid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    PartnerApi.prototype.partnerControllerVoidDonation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PartnerApiFp)(this.configuration)
            .partnerControllerVoidDonation(requestParameters.gid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PartnerApi;
}(base_1.BaseAPI));
exports.PartnerApi = PartnerApi;
var PreviewApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        previewControllerPreviewShopifyOrder: function (campaignGid, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('previewControllerPreviewShopifyOrder', 'campaignGid', campaignGid);
                            localVarPath = "/core/v1/preview";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (campaignGid !== undefined) {
                                localVarQueryParameter['campaignGid'] = campaignGid;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PreviewApiAxiosParamCreator = PreviewApiAxiosParamCreator;
var PreviewApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PreviewApiAxiosParamCreator)(configuration);
    return {
        previewControllerPreviewShopifyOrder: function (campaignGid, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.previewControllerPreviewShopifyOrder(campaignGid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PreviewApiFp = PreviewApiFp;
var PreviewApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PreviewApiFp)(configuration);
    return {
        previewControllerPreviewShopifyOrder: function (campaignGid, options) {
            return localVarFp
                .previewControllerPreviewShopifyOrder(campaignGid, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PreviewApiFactory = PreviewApiFactory;
var PreviewApi = (function (_super) {
    tslib_1.__extends(PreviewApi, _super);
    function PreviewApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PreviewApi.prototype.previewControllerPreviewShopifyOrder = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PreviewApiFp)(this.configuration)
            .previewControllerPreviewShopifyOrder(requestParameters.campaignGid, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PreviewApi;
}(base_1.BaseAPI));
exports.PreviewApi = PreviewApi;
var ReportsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        reportsControllerExportOrganizationsReport: function (page, pageSize, campaignGids, endedAt, startedAt, donationsType, emails, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/reports/organizations/export";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (campaignGids) {
                                localVarQueryParameter['campaignGids'] = campaignGids;
                            }
                            if (endedAt !== undefined) {
                                localVarQueryParameter['endedAt'] =
                                    endedAt instanceof Date
                                        ? endedAt.toISOString()
                                        : endedAt;
                            }
                            if (startedAt !== undefined) {
                                localVarQueryParameter['startedAt'] =
                                    startedAt instanceof Date
                                        ? startedAt.toISOString()
                                        : startedAt;
                            }
                            if (donationsType !== undefined) {
                                localVarQueryParameter['donationsType'] = donationsType;
                            }
                            if (emails) {
                                localVarQueryParameter['emails'] = emails;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        reportsControllerGetOrganizationsReport: function (page, pageSize, campaignGids, endedAt, startedAt, donationsType, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/reports/organizations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (campaignGids) {
                                localVarQueryParameter['campaignGids'] = campaignGids;
                            }
                            if (endedAt !== undefined) {
                                localVarQueryParameter['endedAt'] =
                                    endedAt instanceof Date
                                        ? endedAt.toISOString()
                                        : endedAt;
                            }
                            if (startedAt !== undefined) {
                                localVarQueryParameter['startedAt'] =
                                    startedAt instanceof Date
                                        ? startedAt.toISOString()
                                        : startedAt;
                            }
                            if (donationsType !== undefined) {
                                localVarQueryParameter['donationsType'] = donationsType;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        reportsControllerGetOverviewReport: function (campaignGids, endedAt, startedAt, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/reports/overview";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            if (campaignGids) {
                                localVarQueryParameter['campaignGids'] = campaignGids;
                            }
                            if (endedAt !== undefined) {
                                localVarQueryParameter['endedAt'] =
                                    endedAt instanceof Date
                                        ? endedAt.toISOString()
                                        : endedAt;
                            }
                            if (startedAt !== undefined) {
                                localVarQueryParameter['startedAt'] =
                                    startedAt instanceof Date
                                        ? startedAt.toISOString()
                                        : startedAt;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ReportsApiAxiosParamCreator = ReportsApiAxiosParamCreator;
var ReportsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ReportsApiAxiosParamCreator)(configuration);
    return {
        reportsControllerExportOrganizationsReport: function (page, pageSize, campaignGids, endedAt, startedAt, donationsType, emails, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.reportsControllerExportOrganizationsReport(page, pageSize, campaignGids, endedAt, startedAt, donationsType, emails, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        reportsControllerGetOrganizationsReport: function (page, pageSize, campaignGids, endedAt, startedAt, donationsType, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.reportsControllerGetOrganizationsReport(page, pageSize, campaignGids, endedAt, startedAt, donationsType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        reportsControllerGetOverviewReport: function (campaignGids, endedAt, startedAt, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.reportsControllerGetOverviewReport(campaignGids, endedAt, startedAt, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ReportsApiFp = ReportsApiFp;
var ReportsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ReportsApiFp)(configuration);
    return {
        reportsControllerExportOrganizationsReport: function (page, pageSize, campaignGids, endedAt, startedAt, donationsType, emails, options) {
            return localVarFp
                .reportsControllerExportOrganizationsReport(page, pageSize, campaignGids, endedAt, startedAt, donationsType, emails, options)
                .then(function (request) { return request(axios, basePath); });
        },
        reportsControllerGetOrganizationsReport: function (page, pageSize, campaignGids, endedAt, startedAt, donationsType, options) {
            return localVarFp
                .reportsControllerGetOrganizationsReport(page, pageSize, campaignGids, endedAt, startedAt, donationsType, options)
                .then(function (request) { return request(axios, basePath); });
        },
        reportsControllerGetOverviewReport: function (campaignGids, endedAt, startedAt, options) {
            return localVarFp
                .reportsControllerGetOverviewReport(campaignGids, endedAt, startedAt, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ReportsApiFactory = ReportsApiFactory;
var ReportsApi = (function (_super) {
    tslib_1.__extends(ReportsApi, _super);
    function ReportsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReportsApi.prototype.reportsControllerExportOrganizationsReport = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ReportsApiFp)(this.configuration)
            .reportsControllerExportOrganizationsReport(requestParameters.page, requestParameters.pageSize, requestParameters.campaignGids, requestParameters.endedAt, requestParameters.startedAt, requestParameters.donationsType, requestParameters.emails, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    ReportsApi.prototype.reportsControllerGetOrganizationsReport = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ReportsApiFp)(this.configuration)
            .reportsControllerGetOrganizationsReport(requestParameters.page, requestParameters.pageSize, requestParameters.campaignGids, requestParameters.endedAt, requestParameters.startedAt, requestParameters.donationsType, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    ReportsApi.prototype.reportsControllerGetOverviewReport = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ReportsApiFp)(this.configuration)
            .reportsControllerGetOverviewReport(requestParameters.campaignGids, requestParameters.endedAt, requestParameters.startedAt, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ReportsApi;
}(base_1.BaseAPI));
exports.ReportsApi = ReportsApi;
var ShopifyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        processShopifyOrderControllerProcessPreviewShopifyOrder: function (widgetPreviewOrderCreateDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('processShopifyOrderControllerProcessPreviewShopifyOrder', 'widgetPreviewOrderCreateDto', widgetPreviewOrderCreateDto);
                    localVarPath = "/core/v1/processShopifyOrder/preview";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(widgetPreviewOrderCreateDto, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        processShopifyOrderControllerProcessShopifyOrderFromWidget: function (widgetOrderCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('processShopifyOrderControllerProcessShopifyOrderFromWidget', 'widgetOrderCreate', widgetOrderCreate);
                    localVarPath = "/core/v1/processShopifyOrder";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(widgetOrderCreate, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        processShopifyPageControllerProcessShopifyPage: function (url, campaignGid, shop, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('processShopifyPageControllerProcessShopifyPage', 'url', url);
                    localVarPath = "/core/v1/processShopifyPage";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (campaignGid !== undefined) {
                        localVarQueryParameter['campaignGid'] = campaignGid;
                    }
                    if (shop !== undefined) {
                        localVarQueryParameter['shop'] = shop;
                    }
                    if (url !== undefined) {
                        localVarQueryParameter['url'] = url;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        shopifyAccessTokensControllerCreateShopifyAppAccessToken: function (shopifySession, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('shopifyAccessTokensControllerCreateShopifyAppAccessToken', 'shopifySession', shopifySession);
                    localVarPath = "/core/v1/shopify/accessTokens";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shopifySession, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ShopifyApiAxiosParamCreator = ShopifyApiAxiosParamCreator;
var ShopifyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShopifyApiAxiosParamCreator)(configuration);
    return {
        processShopifyOrderControllerProcessPreviewShopifyOrder: function (widgetPreviewOrderCreateDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.processShopifyOrderControllerProcessPreviewShopifyOrder(widgetPreviewOrderCreateDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        processShopifyOrderControllerProcessShopifyOrderFromWidget: function (widgetOrderCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.processShopifyOrderControllerProcessShopifyOrderFromWidget(widgetOrderCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        processShopifyPageControllerProcessShopifyPage: function (url, campaignGid, shop, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.processShopifyPageControllerProcessShopifyPage(url, campaignGid, shop, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        shopifyAccessTokensControllerCreateShopifyAppAccessToken: function (shopifySession, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.shopifyAccessTokensControllerCreateShopifyAppAccessToken(shopifySession, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ShopifyApiFp = ShopifyApiFp;
var ShopifyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShopifyApiFp)(configuration);
    return {
        processShopifyOrderControllerProcessPreviewShopifyOrder: function (widgetPreviewOrderCreateDto, options) {
            return localVarFp
                .processShopifyOrderControllerProcessPreviewShopifyOrder(widgetPreviewOrderCreateDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        processShopifyOrderControllerProcessShopifyOrderFromWidget: function (widgetOrderCreate, options) {
            return localVarFp
                .processShopifyOrderControllerProcessShopifyOrderFromWidget(widgetOrderCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        processShopifyPageControllerProcessShopifyPage: function (url, campaignGid, shop, options) {
            return localVarFp
                .processShopifyPageControllerProcessShopifyPage(url, campaignGid, shop, options)
                .then(function (request) { return request(axios, basePath); });
        },
        shopifyAccessTokensControllerCreateShopifyAppAccessToken: function (shopifySession, options) {
            return localVarFp
                .shopifyAccessTokensControllerCreateShopifyAppAccessToken(shopifySession, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShopifyApiFactory = ShopifyApiFactory;
var ShopifyApi = (function (_super) {
    tslib_1.__extends(ShopifyApi, _super);
    function ShopifyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyApi.prototype.processShopifyOrderControllerProcessPreviewShopifyOrder = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ShopifyApiFp)(this.configuration)
            .processShopifyOrderControllerProcessPreviewShopifyOrder(requestParameters.widgetPreviewOrderCreateDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    ShopifyApi.prototype.processShopifyOrderControllerProcessShopifyOrderFromWidget = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ShopifyApiFp)(this.configuration)
            .processShopifyOrderControllerProcessShopifyOrderFromWidget(requestParameters.widgetOrderCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    ShopifyApi.prototype.processShopifyPageControllerProcessShopifyPage = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ShopifyApiFp)(this.configuration)
            .processShopifyPageControllerProcessShopifyPage(requestParameters.url, requestParameters.campaignGid, requestParameters.shop, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    ShopifyApi.prototype.shopifyAccessTokensControllerCreateShopifyAppAccessToken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ShopifyApiFp)(this.configuration)
            .shopifyAccessTokensControllerCreateShopifyAppAccessToken(requestParameters.shopifySession, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShopifyApi;
}(base_1.BaseAPI));
exports.ShopifyApi = ShopifyApi;
var SubscriptionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        subscriptionPackagesControllerGetAllSubscriptionPackages: function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/subscriptions/packages";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        subscriptionsControllerCancelPendingSubscription: function (gid, body, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('subscriptionsControllerCancelPendingSubscription', 'gid', gid);
                            (0, common_1.assertParamExists)('subscriptionsControllerCancelPendingSubscription', 'body', body);
                            localVarPath = "/core/v1/subscriptions/{gid}".replace("{".concat('gid', "}"), encodeURIComponent(String(gid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        subscriptionsControllerCreateSubscription: function (subscriptionCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            (0, common_1.assertParamExists)('subscriptionsControllerCreateSubscription', 'subscriptionCreate', subscriptionCreate);
                            localVarPath = "/core/v1/subscriptions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(subscriptionCreate, localVarRequestOptions, configuration);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        subscriptionsControllerSearchSubscriptions: function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/subscriptions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SubscriptionsApiAxiosParamCreator = SubscriptionsApiAxiosParamCreator;
var SubscriptionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SubscriptionsApiAxiosParamCreator)(configuration);
    return {
        subscriptionPackagesControllerGetAllSubscriptionPackages: function (options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.subscriptionPackagesControllerGetAllSubscriptionPackages(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        subscriptionsControllerCancelPendingSubscription: function (gid, body, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.subscriptionsControllerCancelPendingSubscription(gid, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        subscriptionsControllerCreateSubscription: function (subscriptionCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.subscriptionsControllerCreateSubscription(subscriptionCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        subscriptionsControllerSearchSubscriptions: function (options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.subscriptionsControllerSearchSubscriptions(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SubscriptionsApiFp = SubscriptionsApiFp;
var SubscriptionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SubscriptionsApiFp)(configuration);
    return {
        subscriptionPackagesControllerGetAllSubscriptionPackages: function (options) {
            return localVarFp
                .subscriptionPackagesControllerGetAllSubscriptionPackages(options)
                .then(function (request) { return request(axios, basePath); });
        },
        subscriptionsControllerCancelPendingSubscription: function (gid, body, options) {
            return localVarFp
                .subscriptionsControllerCancelPendingSubscription(gid, body, options)
                .then(function (request) { return request(axios, basePath); });
        },
        subscriptionsControllerCreateSubscription: function (subscriptionCreate, options) {
            return localVarFp
                .subscriptionsControllerCreateSubscription(subscriptionCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        subscriptionsControllerSearchSubscriptions: function (options) {
            return localVarFp
                .subscriptionsControllerSearchSubscriptions(options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SubscriptionsApiFactory = SubscriptionsApiFactory;
var SubscriptionsApi = (function (_super) {
    tslib_1.__extends(SubscriptionsApi, _super);
    function SubscriptionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubscriptionsApi.prototype.subscriptionPackagesControllerGetAllSubscriptionPackages = function (options) {
        var _this = this;
        return (0, exports.SubscriptionsApiFp)(this.configuration)
            .subscriptionPackagesControllerGetAllSubscriptionPackages(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    SubscriptionsApi.prototype.subscriptionsControllerCancelPendingSubscription = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SubscriptionsApiFp)(this.configuration)
            .subscriptionsControllerCancelPendingSubscription(requestParameters.gid, requestParameters.body, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    SubscriptionsApi.prototype.subscriptionsControllerCreateSubscription = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SubscriptionsApiFp)(this.configuration)
            .subscriptionsControllerCreateSubscription(requestParameters.subscriptionCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    SubscriptionsApi.prototype.subscriptionsControllerSearchSubscriptions = function (options) {
        var _this = this;
        return (0, exports.SubscriptionsApiFp)(this.configuration)
            .subscriptionsControllerSearchSubscriptions(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SubscriptionsApi;
}(base_1.BaseAPI));
exports.SubscriptionsApi = SubscriptionsApi;
var TrackApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        trackControllerTrackDevice: function (givzDeviceId, deviceCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('trackControllerTrackDevice', 'givzDeviceId', givzDeviceId);
                    (0, common_1.assertParamExists)('trackControllerTrackDevice', 'deviceCreate', deviceCreate);
                    localVarPath = "/core/v1/track/device";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (givzDeviceId !== undefined && givzDeviceId !== null) {
                        localVarHeaderParameter['givz_device_id'] = String(givzDeviceId);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deviceCreate, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TrackApiAxiosParamCreator = TrackApiAxiosParamCreator;
var TrackApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TrackApiAxiosParamCreator)(configuration);
    return {
        trackControllerTrackDevice: function (givzDeviceId, deviceCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.trackControllerTrackDevice(givzDeviceId, deviceCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TrackApiFp = TrackApiFp;
var TrackApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TrackApiFp)(configuration);
    return {
        trackControllerTrackDevice: function (givzDeviceId, deviceCreate, options) {
            return localVarFp
                .trackControllerTrackDevice(givzDeviceId, deviceCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TrackApiFactory = TrackApiFactory;
var TrackApi = (function (_super) {
    tslib_1.__extends(TrackApi, _super);
    function TrackApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TrackApi.prototype.trackControllerTrackDevice = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TrackApiFp)(this.configuration)
            .trackControllerTrackDevice(requestParameters.givzDeviceId, requestParameters.deviceCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TrackApi;
}(base_1.BaseAPI));
exports.TrackApi = TrackApi;
var UtilitiesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        appControllerHealthCheck: function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    localVarPath = "/core/v1/ping";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.UtilitiesApiAxiosParamCreator = UtilitiesApiAxiosParamCreator;
var UtilitiesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UtilitiesApiAxiosParamCreator)(configuration);
    return {
        appControllerHealthCheck: function (options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.appControllerHealthCheck(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.UtilitiesApiFp = UtilitiesApiFp;
var UtilitiesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UtilitiesApiFp)(configuration);
    return {
        appControllerHealthCheck: function (options) {
            return localVarFp
                .appControllerHealthCheck(options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UtilitiesApiFactory = UtilitiesApiFactory;
var UtilitiesApi = (function (_super) {
    tslib_1.__extends(UtilitiesApi, _super);
    function UtilitiesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UtilitiesApi.prototype.appControllerHealthCheck = function (options) {
        var _this = this;
        return (0, exports.UtilitiesApiFp)(this.configuration)
            .appControllerHealthCheck(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UtilitiesApi;
}(base_1.BaseAPI));
exports.UtilitiesApi = UtilitiesApi;
var WebhooksApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        hubspotWebhooksControllerHubspot: function (hubspotWebhookDto, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('hubspotWebhooksControllerHubspot', 'hubspotWebhookDto', hubspotWebhookDto);
                    localVarPath = "/core/v1/webhooks/hubspot";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hubspotWebhookDto, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        paypalWebhooksControllerPaypal: function (payoutBatchWebhookBody, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('paypalWebhooksControllerPaypal', 'payoutBatchWebhookBody', payoutBatchWebhookBody);
                    localVarPath = "/core/v1/webhooks/paypal";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(payoutBatchWebhookBody, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        shopifyWebhooksControllerGdpr: function (type, customersRedactShopRedactCustomersDataRequest, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('shopifyWebhooksControllerGdpr', 'type', type);
                    (0, common_1.assertParamExists)('shopifyWebhooksControllerGdpr', 'customersRedactShopRedactCustomersDataRequest', customersRedactShopRedactCustomersDataRequest);
                    localVarPath = "/core/v1/webhooks/shopify/gdpr/{type}".replace("{".concat('type', "}"), encodeURIComponent(String(type)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customersRedactShopRedactCustomersDataRequest, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        shopifyWebhooksControllerOrder: function (xShopifyShopDomain, xShopifyTopic, shopifyOrderCreate, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('shopifyWebhooksControllerOrder', 'xShopifyShopDomain', xShopifyShopDomain);
                    (0, common_1.assertParamExists)('shopifyWebhooksControllerOrder', 'xShopifyTopic', xShopifyTopic);
                    (0, common_1.assertParamExists)('shopifyWebhooksControllerOrder', 'shopifyOrderCreate', shopifyOrderCreate);
                    localVarPath = "/core/v1/webhooks/shopify/order";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xShopifyShopDomain !== undefined && xShopifyShopDomain !== null) {
                        localVarHeaderParameter['x-shopify-shop-domain'] =
                            String(xShopifyShopDomain);
                    }
                    if (xShopifyTopic !== undefined && xShopifyTopic !== null) {
                        localVarHeaderParameter['x-shopify-topic'] = String(xShopifyTopic);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shopifyOrderCreate, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        shopifyWebhooksControllerShop: function (shop, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('shopifyWebhooksControllerShop', 'shop', shop);
                    localVarPath = "/core/v1/webhooks/shopify/shop";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shop, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        shopifyWebhooksControllerUninstall: function (shop, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('shopifyWebhooksControllerUninstall', 'shop', shop);
                    localVarPath = "/core/v1/webhooks/shopify/uninstall";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shop, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        stripeWebhooksControllerStripe: function (stripeWebhookInvoice, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    (0, common_1.assertParamExists)('stripeWebhooksControllerStripe', 'stripeWebhookInvoice', stripeWebhookInvoice);
                    localVarPath = "/core/v1/webhooks/stripe";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(stripeWebhookInvoice, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.WebhooksApiAxiosParamCreator = WebhooksApiAxiosParamCreator;
var WebhooksApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.WebhooksApiAxiosParamCreator)(configuration);
    return {
        hubspotWebhooksControllerHubspot: function (hubspotWebhookDto, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.hubspotWebhooksControllerHubspot(hubspotWebhookDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        paypalWebhooksControllerPaypal: function (payoutBatchWebhookBody, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.paypalWebhooksControllerPaypal(payoutBatchWebhookBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        shopifyWebhooksControllerGdpr: function (type, customersRedactShopRedactCustomersDataRequest, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.shopifyWebhooksControllerGdpr(type, customersRedactShopRedactCustomersDataRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        shopifyWebhooksControllerOrder: function (xShopifyShopDomain, xShopifyTopic, shopifyOrderCreate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.shopifyWebhooksControllerOrder(xShopifyShopDomain, xShopifyTopic, shopifyOrderCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        shopifyWebhooksControllerShop: function (shop, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.shopifyWebhooksControllerShop(shop, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        shopifyWebhooksControllerUninstall: function (shop, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.shopifyWebhooksControllerUninstall(shop, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        stripeWebhooksControllerStripe: function (stripeWebhookInvoice, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.stripeWebhooksControllerStripe(stripeWebhookInvoice, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.WebhooksApiFp = WebhooksApiFp;
var WebhooksApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.WebhooksApiFp)(configuration);
    return {
        hubspotWebhooksControllerHubspot: function (hubspotWebhookDto, options) {
            return localVarFp
                .hubspotWebhooksControllerHubspot(hubspotWebhookDto, options)
                .then(function (request) { return request(axios, basePath); });
        },
        paypalWebhooksControllerPaypal: function (payoutBatchWebhookBody, options) {
            return localVarFp
                .paypalWebhooksControllerPaypal(payoutBatchWebhookBody, options)
                .then(function (request) { return request(axios, basePath); });
        },
        shopifyWebhooksControllerGdpr: function (type, customersRedactShopRedactCustomersDataRequest, options) {
            return localVarFp
                .shopifyWebhooksControllerGdpr(type, customersRedactShopRedactCustomersDataRequest, options)
                .then(function (request) { return request(axios, basePath); });
        },
        shopifyWebhooksControllerOrder: function (xShopifyShopDomain, xShopifyTopic, shopifyOrderCreate, options) {
            return localVarFp
                .shopifyWebhooksControllerOrder(xShopifyShopDomain, xShopifyTopic, shopifyOrderCreate, options)
                .then(function (request) { return request(axios, basePath); });
        },
        shopifyWebhooksControllerShop: function (shop, options) {
            return localVarFp
                .shopifyWebhooksControllerShop(shop, options)
                .then(function (request) { return request(axios, basePath); });
        },
        shopifyWebhooksControllerUninstall: function (shop, options) {
            return localVarFp
                .shopifyWebhooksControllerUninstall(shop, options)
                .then(function (request) { return request(axios, basePath); });
        },
        stripeWebhooksControllerStripe: function (stripeWebhookInvoice, options) {
            return localVarFp
                .stripeWebhooksControllerStripe(stripeWebhookInvoice, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.WebhooksApiFactory = WebhooksApiFactory;
var WebhooksApi = (function (_super) {
    tslib_1.__extends(WebhooksApi, _super);
    function WebhooksApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebhooksApi.prototype.hubspotWebhooksControllerHubspot = function (requestParameters, options) {
        var _this = this;
        return (0, exports.WebhooksApiFp)(this.configuration)
            .hubspotWebhooksControllerHubspot(requestParameters.hubspotWebhookDto, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    WebhooksApi.prototype.paypalWebhooksControllerPaypal = function (requestParameters, options) {
        var _this = this;
        return (0, exports.WebhooksApiFp)(this.configuration)
            .paypalWebhooksControllerPaypal(requestParameters.payoutBatchWebhookBody, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    WebhooksApi.prototype.shopifyWebhooksControllerGdpr = function (requestParameters, options) {
        var _this = this;
        return (0, exports.WebhooksApiFp)(this.configuration)
            .shopifyWebhooksControllerGdpr(requestParameters.type, requestParameters.customersRedactShopRedactCustomersDataRequest, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    WebhooksApi.prototype.shopifyWebhooksControllerOrder = function (requestParameters, options) {
        var _this = this;
        return (0, exports.WebhooksApiFp)(this.configuration)
            .shopifyWebhooksControllerOrder(requestParameters.xShopifyShopDomain, requestParameters.xShopifyTopic, requestParameters.shopifyOrderCreate, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    WebhooksApi.prototype.shopifyWebhooksControllerShop = function (requestParameters, options) {
        var _this = this;
        return (0, exports.WebhooksApiFp)(this.configuration)
            .shopifyWebhooksControllerShop(requestParameters.shop, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    WebhooksApi.prototype.shopifyWebhooksControllerUninstall = function (requestParameters, options) {
        var _this = this;
        return (0, exports.WebhooksApiFp)(this.configuration)
            .shopifyWebhooksControllerUninstall(requestParameters.shop, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    WebhooksApi.prototype.stripeWebhooksControllerStripe = function (requestParameters, options) {
        var _this = this;
        return (0, exports.WebhooksApiFp)(this.configuration)
            .stripeWebhooksControllerStripe(requestParameters.stripeWebhookInvoice, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WebhooksApi;
}(base_1.BaseAPI));
exports.WebhooksApi = WebhooksApi;
var WidgetApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        widgetControllerGetShopifyPrePurchaseWidget: function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/widget/shopifyPrePurchase";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        widgetControllerInstallShopifyPrePurchaseWidget: function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/widget/shopifyPrePurchase/install";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        widgetControllerUninstallShopifyPrePurchaseWidget: function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/core/v1/widget/shopifyPrePurchase/uninstall";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = tslib_1.__assign(tslib_1.__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            return [4, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.WidgetApiAxiosParamCreator = WidgetApiAxiosParamCreator;
var WidgetApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.WidgetApiAxiosParamCreator)(configuration);
    return {
        widgetControllerGetShopifyPrePurchaseWidget: function (options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.widgetControllerGetShopifyPrePurchaseWidget(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        widgetControllerInstallShopifyPrePurchaseWidget: function (options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.widgetControllerInstallShopifyPrePurchaseWidget(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        widgetControllerUninstallShopifyPrePurchaseWidget: function (options) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.widgetControllerUninstallShopifyPrePurchaseWidget(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.WidgetApiFp = WidgetApiFp;
var WidgetApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.WidgetApiFp)(configuration);
    return {
        widgetControllerGetShopifyPrePurchaseWidget: function (options) {
            return localVarFp
                .widgetControllerGetShopifyPrePurchaseWidget(options)
                .then(function (request) { return request(axios, basePath); });
        },
        widgetControllerInstallShopifyPrePurchaseWidget: function (options) {
            return localVarFp
                .widgetControllerInstallShopifyPrePurchaseWidget(options)
                .then(function (request) { return request(axios, basePath); });
        },
        widgetControllerUninstallShopifyPrePurchaseWidget: function (options) {
            return localVarFp
                .widgetControllerUninstallShopifyPrePurchaseWidget(options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.WidgetApiFactory = WidgetApiFactory;
var WidgetApi = (function (_super) {
    tslib_1.__extends(WidgetApi, _super);
    function WidgetApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WidgetApi.prototype.widgetControllerGetShopifyPrePurchaseWidget = function (options) {
        var _this = this;
        return (0, exports.WidgetApiFp)(this.configuration)
            .widgetControllerGetShopifyPrePurchaseWidget(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    WidgetApi.prototype.widgetControllerInstallShopifyPrePurchaseWidget = function (options) {
        var _this = this;
        return (0, exports.WidgetApiFp)(this.configuration)
            .widgetControllerInstallShopifyPrePurchaseWidget(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    WidgetApi.prototype.widgetControllerUninstallShopifyPrePurchaseWidget = function (options) {
        var _this = this;
        return (0, exports.WidgetApiFp)(this.configuration)
            .widgetControllerUninstallShopifyPrePurchaseWidget(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WidgetApi;
}(base_1.BaseAPI));
exports.WidgetApi = WidgetApi;
//# sourceMappingURL=api.js.map